interface Conversion {
    dolarPrice?: number | any;
    dolarPriceCurrency?: string | any;
}

export interface IUpdateBankAccountRequest {
    raffleId: string;
    bankAccounts: BankAccountItem[];
}

export interface BankAccountItem {
    bankId?: 'santander'
| 'bancofalabella'
| 'bancogeneralpanama'
| 'payway'
| 'tapp'
| 'cuentanaranja'
| 'banreservas'
| 'bancochile'
| 'nickel'
| 'pagomovil'
| 'majority'
| 'bicentenario'
| 'bancodeltesoro'
| 'wise'
| 'pichincha'
| 'cashapp'
| 'bancoestado'
| 'scotiabank'
| 'tenpo'
| 'banco-exterior'
| 'provincial'
| 'caixabank'
| 'mercadopago'
| 'paypal'
| 'bcp'
| 'lemoncash'
| 'bbva'
| 'caja-social'
| 'bci'
| 'zinli'
| 'mercantil'
| 'bancodeguayaquil'
| 'binance'
| 'plin'
| 'bancolombia'
| 'cash'
| 'bdt'
| 'nequi'
| 'zelle'
| 'yape'
| 'bancaribe'
| 'bnc'
| 'bancodevenezuela'
| 'bizum'
| 'bancaamiga'
| 'banesco';
    name: string;
    href?: string;
    dni?: string;
    bank?: string;
    accountType?: string;
    address?: string;
    accountNumber?: string;
    phone?: string;
    ticketPrice: string;
    ticketPriceAmount: number;
    ticketCurrency: string;
    conversion?: Conversion;
    hide?: boolean;
}

interface BankAccountConfig {
    accountId: string;
    bankAccounts: BankAccountItem[]
}

export const BANK_ACCOUNTS: BankAccountConfig[] = [
    {
        accountId: "agudojhonny",
        bankAccounts: [
        {
            name: "Jose Alfonso",
            dni: "RUT: 27.146.773-7",
            bank: "Banco Falabella 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "15842418179",
            ticketPrice: "8000CLP",
            ticketPriceAmount: 8000,
            ticketCurrency: "CLP",
            conversion: {
                dolarPrice: 0,
                dolarPriceCurrency: ""
            },
            bankId: "bancofalabella"
        },
        {
            name: "Banco de Venezuela",
            dni: "Cédula: V24.149.878",
            bank: "Banco de Venezuela 🇻🇪",
            accountType: "Pago movil",
            accountNumber: "04120492515",
            ticketPrice: "1520bs",
            ticketPriceAmount: 1520,
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 190,
                dolarPriceCurrency: "BS"
            },
            bankId: "bancodevenezuela"
        },
        {
            name: "Arte Arichuna LLC",
            dni: "Minima compra 2 tickets. Colocar numero de confirmacion completo. ",
            bank: "Zelle 🇺🇸",
            accountNumber: "motopiruetaesartee@gmail.com",
            ticketPrice: "$8 dolares",
            ticketPriceAmount: 8,
            ticketCurrency: "USD",
            conversion: {
                "dolarPrice": 0,
                "dolarPriceCurrency": ""
            },
            bankId: "zelle"
        },
        {
            name: "MOTOPIRUETAESARTE",
            bank: "Binance",
            accountNumber: "Binance ID: 1138591166",
            ticketPrice: "$8 USDT",
            ticketPriceAmount: 8,
            ticketCurrency: "USD",
            conversion: {
                "dolarPrice": 0,
                "dolarPriceCurrency": ""
            },
            bankId: "binance"
        },
        {
            bankId: 'bizum',
            bank: "Bizum 🇪🇸",
            name: 'Yesimar Malvacia',
            accountNumber: 'IBAN ES 4501 8276 7763 0201673815',
            ticketPrice: "$8 euros",
            ticketPriceAmount: 8,
            ticketCurrency: "USD"
        },
    ]
    }, 
    {
        accountId: "samuel-peralta",
        bankAccounts: [
        {
            name: "Banco de Venezuela",
            dni: "Cédula: V31.531.476",
            bank: "Banco de Venezuela 🇻🇪",
            accountType: "Pago movil",
            accountNumber: "04122884802",
            ticketPrice: "410bs",
            ticketPriceAmount: 410,
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 205,
                dolarPriceCurrency: "BS"
            },
            bankId: "bancodevenezuela"
        },
        {
            bankId: 'mercadopago',
            name: "Rusvelys Cirimar Bello Gonzalez",
            dni: "Rut: 26291287-6",
            bank: "Mercado Pago 🇨🇱",
            accountType: "Cuenta Vista",
            accountNumber: "1021792240",
            ticketPrice: "2000 pesos",
            ticketPriceAmount: 2000,
            href: '-',
            ticketCurrency: "CLP"
        },
        {
            name: "ddasher079@gmail.com",
            dni: "Minima compra 2 tickets.",
            bank: "Zelle 🇺🇸",
            accountNumber: "ddasher079@gmail.com",
            ticketPrice: "$2 dolares",
            ticketPriceAmount: 2,
            ticketCurrency: "USD",
            conversion: {
                "dolarPrice": 0,
                "dolarPriceCurrency": ""
            },
            bankId: "zelle"
        },
    ]
    }, 
    {
        accountId: "greko-rifando",
        bankAccounts: [
            {
                bankId: "bnc",
                 name: "Banco Nacional De Crédito",
                 dni: "Cédula: V23.904.060",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04241413220",
                 ticketPrice: "140bs",
                 ticketPriceAmount: 140,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 140,
                     dolarPriceCurrency: "BS",
                 }
             },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Kevin Marquez',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "4699655162",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "kevin-munoz",
        bankAccounts: [
                {
                bankId: "mercantil",
                 name: "Banco Mercantil",
                 dni: "Cédula: V17.710.020",
                 bank: "Banco Mercantil 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04123855758",
                 ticketPrice: "153bs",
                 ticketPriceAmount: 153,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 153,
                     dolarPriceCurrency: "BS",
                 }
             },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Franyelis Colina',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "franyeliscolina0@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },  
    {
        accountId: "rifas-jcc",
        bankAccounts: [
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Inocencio altuve',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "4807977154",
                ticketPrice: "$6 dólares",
                ticketPriceAmount: 6,
                ticketCurrency: "USD"
            },
        ]
    },  
    {
        accountId: "exi-rifas",
        bankAccounts: [
            { 
                bankId: 'bancoestado',
                name: "Arianna García",
                dni: "Rut: 28056764-7",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "28056764",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "bancofalabella",
                name: "Arianna García",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "15330168136",
                dni: "RUT: 28056764-7",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                ticketCurrency: "CLP"
            },
            { 
                bankId: 'bancoestado',
                name: "Gustavo Escobar",
                dni: "Rut: 26.203.151-9",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "26203151",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "santander",
                name: "Gustavo Escobar",
                dni: "RUT: 26.203.151-9",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "81878412",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                ticketCurrency: "CLP"
            },
        ]
    },  
    {
        accountId: "el-de-la-h",
        bankAccounts: [
                {
                bankId: "bancodevenezuela",
                 name: "Banco: Venezuela",
                 dni: "Cédula: V11.099.206",
                 bank: "Banco Mercantil 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04145846954",
                 ticketPrice: "595 BS",
                 ticketPriceAmount: 595,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 170,
                     dolarPriceCurrency: "BS",
                 }
             },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Franyelis Colina',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "Franyelis Mendoza",
                ticketPrice: "$3.5 dólar",
                ticketPriceAmount: 3.5,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "diego-merchan",
        bankAccounts: [
            {
                bankId: "bancofalabella",
                name: "Diego MENDEZ",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "15410177952",
                dni: "RUT: 27.806.751-3",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Carlos Daniel Mendez Merchan",
                dni: "Rut: 26709187-0",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1058298234",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancodevenezuela',
                name: "Glenda Mendoza ",
                dni: "Cédula: V-24.584.945",
                bank: "Banco de Venezuela🇻🇪",
                accountNumber: "-",
                phone: "04147037315",
                accountType: "Pago móvil",
                ticketPrice: "280Bs",
                ticketPriceAmount: 280,
                href: '-',
                ticketCurrency: "BS",
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Christel Gomez',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "andreangomez20@gmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "la-barberia",
        bankAccounts: [
            { 
                bankId: 'bancoestado',
                name: "MARIA GABRIELA MUNOZ AICARDI",
                dni: "Rut: 28636024-6",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "28636024",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "bancofalabella",
                name: "Maria MUNOZ",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "15170185740",
                dni: "RUT: 28.636.024-6",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Aicardi Maria Munoz",
                dni: "Rut: 28636024-6",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1053151558",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "tenpo",
                name: "MARIA GABRIELA MUNOZ AICARDI",
                bank: "Banco prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111128636024",
                dni: "RUT: 28636024-6",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                ticketCurrency: "CLP"
            },
            {
                bankId: "bci",
                name: "MARIA GABRIELA MUNOZ AICARDI",
                dni: "RUT: 28.636.024-6",
                bank: "Banco BCI🇨🇱",
                accountNumber: "777928636024",
                accountType: "Cuenta Corriente",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP",
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Lenin Antonio',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "leninantonio_118@hotmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "rifas-yaracuy",
        bankAccounts: [
            {
                bankId: "tenpo",
                name: "STEFHANY ANDREINA ARELLANO FIGUEROA",
                bank: "Banco prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111127130141",
                dni: "RUT: 27130141-3",
                ticketPrice: "1000 CLP",
                ticketPriceAmount: 1000,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'provincial',
                name: "JUAN CARLOS LEON",
                dni: "Cédula: V-12.081.801",
                bank: "Provincial 🇻🇪",
                accountNumber: "0108-2447-83-0200180906",
                accountType: "Ahorro",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: '-',
                ticketCurrency: "BS",
            },
             {
                bankId: 'provincial',
                name: "JUAN CARLOS LEON",
                dni: "Cédula: V-12.081.801",
                bank: "Provincial 🇻🇪",
                accountNumber: "-",
                phone: "04120535741",
                accountType: "Pago móvil",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: '-',
                ticketCurrency: "BS",
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Víctor Acosta',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "2107651282",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            { 
                bankId: 'bancoestado',
                name: "Stefany Arellano",
                dni: "Rut: 27-130-141-3",
                bank: "Banco Estado",
                accountType: "Caja vecina",
                accountNumber: "-",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "yape",
                name: "Luis Rafael Martínez Martínez",
                bank: "Yape",
                accountType: "Yape",
                accountNumber: "-",
                phone: '922796228',
                ticketPrice: "4 SOL",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            },
        ]
    }, 
    {
        accountId: "rifas-de-paquete",
        bankAccounts: [
            {
                name: "Banesco",
                dni: "Cédula: V-10.249.506",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04124227185",
                accountType: "Pago móvil",
                ticketPrice: "270Bs",
                ticketPriceAmount: 270,
                href: '-',
                ticketCurrency: "BS",
            },
                {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Erick Vegas',
                accountNumber: "3614360063",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
           { 
                bankId: 'bancoestado',
                name: "Andrey Añez",
                dni: "Rut: 27.192.236-1",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27192236",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },  
    {
        accountId: "rifas-pc",
        bankAccounts: [
            {
                name: "Banesco",
                dni: "Cédula: V-8.600.470",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04124301901",
                accountType: "Pago móvil",
                ticketPrice: "200Bs",
                ticketPriceAmount: 200,
                href: '-',
                ticketCurrency: "BS",
            },
                {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Yusleibi Celis',
                accountNumber: "+1(401)545-3107",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
           {
                bankId: "bancofalabella",
                name: "NELSON FELIPE",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "019801557931",
                dni: "RUT: 18.169.905-1",
                ticketPrice: "1000 CLP",
                ticketPriceAmount: 1000,
                ticketCurrency: "CLP"
            },
        ]
    },     
    {
        accountId: "el-loco-jonder",
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                 name: "Aileen Mendez",
                 dni: "Cédula: V16.362.104",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04142136894",
                 ticketPrice: "180bs",
                 ticketPriceAmount: 180,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 180,
                     dolarPriceCurrency: "BS",
                 }
             },
                {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'jonder.marketing@gmail.com',
                accountNumber: "jonder.marketing@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'noctropolix5@gmail.com',
                accountNumber: "noctropolix5@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Paypal",
                dni: 'Colocar en concepto: Pago rifa',
                accountNumber: "jonder.marketing@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },  
    {
  accountId: "afortunados",
  bankAccounts: [
        {
            bankId: "banesco",
            name: "Banesco",
            dni: "Cédula: 33.497.933",
            bank: "Banesco - Pago Móvil 🇻🇪",
            accountNumber: "-",
            phone: "04129616273",
            accountType: "Pago móvil",
            ticketPrice: "200Bs",
            ticketPriceAmount: 200,
            ticketCurrency: "BS",
        },
        {
            bankId: "zelle",
            bank: "Zelle 🇺🇸",
            name: "Daniel Steven Ferreira",
            accountNumber: "daniferrerdjve@gmail.com",
            ticketPrice: "$2 dólar",
            ticketPriceAmount: 2,
            ticketCurrency: "USD"
        },
        {
            bankId: "santander",
            name: "Sthalin Molina Ferreira",
            dni: "RUT: 27.041.879-1",
            bank: "Banco Santander 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "000089620589",
            ticketPrice: "2000 CLP",
            ticketPriceAmount: 2000,
            ticketCurrency: "CLP"
        },
        {
            bankId: 'mercadopago',
            name: "Sthalin Jacinto Molina Ferreira",
            dni: "Rut: 27041879-1",
            bank: "Mercado Pago 🇨🇱",
            accountType: "Cuenta Vista",
            accountNumber: "1090770459",
            ticketPrice: "2000 pesos",
            ticketPriceAmount: 2000,
            href: '-',
            ticketCurrency: "CLP"
        },
        {
            bankId: "bancofalabella",
            name: "Sthalin MOLINA",
            bank: "Banco Falabella 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "15870098596",
            dni: "RUT: 27.041.879-1",
            ticketPrice: "2000 CLP",
            ticketPriceAmount: 2000,
            ticketCurrency: "CLP"
        },
        {
            bankId: "tenpo",
            name: "STHALIN MOLINA",
            bank: "Banco prepago Tenpo 🇨🇱",
            accountType: "Cuenta Vista",
            accountNumber: "111127041879",
            dni: "RUT: 27041879-1",
            ticketPrice: "2000 CLP",
            ticketPriceAmount: 2000,
            ticketCurrency: "CLP"
        },
    ]
    },
    {
        accountId: "san-de-tu-suerte",
        bankAccounts: [
            {
                bankId: 'bancodevenezuela',
                name: "Banco de Venezuela",
                dni: "Cédula: V-21.283.214",
                bank: "Banco de Venezuela🇻🇪",
                accountNumber: "04123626082",
                accountType: "Pago Movil",
                ticketPrice: "1200Bs",
                ticketPriceAmount: 1200,
                href: '-',
                conversion: {
                    dolarPrice: 240,
                    dolarPriceCurrency: "BS",
                },
                ticketCurrency: "BS",
            },

            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'cinthyaperdomo2814@icloud.com',
                accountNumber: 'cinthyaperdomo2814@icloud.com',
                ticketPrice: "$5 dólares",
                ticketPriceAmount: 5,
                ticketCurrency: "USD"
            },
            
        ]
    }, 
    {
        accountId: "andrusth-barber",
        bankAccounts: [
            {
                bankId: 'bcp',
                name: 'BCP',
                bank: 'BCP',
                accountType: "Ahorros",
                accountNumber: "57007028687037",
                ticketPrice: "$5 soles",
                ticketPriceAmount: 5,
                ticketCurrency: "SOL"
            },
            {
                bankId: 'banesco',
                bank: "Banesco",
                name: 'VANESSA CAROLINA SOJO MOYA',
                dni: 'V-20.357.182',
                accountNumber: '0134-0171-33-1711080374',
                ticketPrice: "$180 bs",
                ticketPriceAmount: 180,
                ticketCurrency: "BS"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Carmen Sabino',
                accountNumber: '9715072909',
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                accountType: 'Nequi',
                name: "Jackson Hernandez",
                accountNumber: "320 629 0970",
                ticketPrice: "$15000 COP",
                ticketPriceAmount: 15000,
                ticketCurrency: "USD"
            },
            { 
                bankId: 'bancoestado',
                name: "Andrés Sojo",
                dni: "Rut: 26.591.067-K",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27908418",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "bancofalabella",
                name: "ANDRÉS SOJO",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "19801236150",
                dni: "RUT: 26.591.067-K",
                ticketPrice: "1000 CLP",
                ticketPriceAmount: 1000,
                ticketCurrency: "CLP"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "Binance ID: 1016463521 ",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            }
        ]
    }, 
    {
        accountId: "jayakuza",
        bankAccounts: [
           {
            
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Jose Rodriguez',
                accountNumber: "+1(856)726-1011",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'banesco',
                bank: "Banesco",
                name: 'Anthony Araujo ',
                dni: 'V-30.250.273',
                accountNumber: '-',
                phone: '04120923178',
                ticketPrice: "$200 bs",
                ticketPriceAmount: 200,
                ticketCurrency: "BS"
            },
           {
                bankId: "majority",
                bank: "Majority 🇺🇸",
                name: 'Alexander',
                accountNumber: "Q (640)258-9775",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            
        ]
    }, 
    {
        accountId: "juega-con-zapata",
        bankAccounts: [
             {
                bankId: 'bnc',
                bank: "Banco Nacional De Credito",
                name: 'Banco Nacional De Credito',
                dni: 'V-29.910.536',
                accountType: 'Pago Móvil',
                accountNumber: '-',
                phone: '04241544181',
                ticketPrice: "600 BS",
                ticketPriceAmount: 600,
                ticketCurrency: "BS"
            },
                {
                bankId: 'banesco',
                bank: "Banesco",
                name: 'Banesco',
                dni: 'V-18.325.974',
                accountNumber: '-',
                accountType: 'Pago Móvil',
                phone: '04242277332',
                ticketPrice: "600 bs",
                ticketPriceAmount: 600,
                ticketCurrency: "BS"
            },
            {
                bankId: 'bnc',
                bank: "Banco Nacional De Credito",
                name: 'Banco Nacional De Credito',
                dni: 'V-29.910.536',
                accountType: 'Corriente',
                accountNumber: '0191-0124-00-2100073398',
                ticketPrice: "600 BS",
                ticketPriceAmount: 600,
                ticketCurrency: "BS"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'stefanyzapata925@gmail.com',
                accountNumber: "Binance ID: 1017470591",
                ticketPrice: "$4 dólares",
                ticketPriceAmount: 4,
                ticketCurrency: "USD"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Roger Casanova',
                accountNumber: "OZZIEDEOZ@GMAIL.COM",
                ticketPrice: "$4 dólares",
                ticketPriceAmount: 4,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bizum',
                bank: "Bizum 🇪🇸",
                name: 'Simoney Sandoval',
                accountNumber: '601 36 9910',
                ticketPrice: "$4 euros",
                ticketPriceAmount: 4,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "gn-rifas",
        bankAccounts: [   
            {
                bankId: "bancofalabella",
                name: "Jesus ROJAS",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "15170190303",
                dni: "RUT: 26.971.669-K",
                ticketPrice: "500 CLP",
                ticketPriceAmount: 500,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Juan Humberto Lupi Rojas",
                dni: "Rut: 26336755-3",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1093537448",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },

            {
                bankId: 'banesco',
                name: "María labrador",
                dni: "Cédula: V-14.281.314",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04242026199",
                accountType: "Pago móvil",
                ticketPrice: "70Bs",
                ticketPriceAmount: 70,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Jesus Rojas",
                accountNumber: "jesusrojas2809@gmail.com",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Edgar Eduardo García nieto',
                accountNumber: "2108276478",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "rifas-va",
        bankAccounts: [
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Jhostin Parra',
                accountNumber: "jhostinparra456@gmail.com",
                ticketPrice: "$2.5 dólares",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "bancofalabella",
                name: "Jonatan Vergara",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "19998580772",
                dni: "RUT: 27.001.025-3",
                ticketPrice: "2500 CLP",
                ticketPriceAmount: 2500,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'provincial',
                name: "LILIANA CONTRERAS",
                dni: "Cédula: V-18.636.576",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04242026199",
                accountType: "Pago móvil",
                ticketPrice: "350Bs",
                ticketPriceAmount: 350,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    }, 
    {
        accountId: "easy-cars",
        bankAccounts: [
            {
                bankId: 'bancodevenezuela',
                name: "BDV",
                dni: "Cédula: V-28.103.443",
                bank: "Banco de Venezuela🇻🇪",
                accountNumber: "-",
                phone: "04123095857",
                accountType: "Pago móvil",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Warren alaña',
                accountNumber: "carlos.josep070295@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "gana-con-bonis",
        bankAccounts: [
            {
                bankId: 'bancodevenezuela',
                name: "BDV",
                dni: "Cédula: V-22.046.313",
                bank: "Banco de Venezuela🇻🇪",
                accountNumber: "-",
                phone: "04125836024",
                accountType: "Pago móvil",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Zelle',
                accountNumber: "elsazondeleonorllc@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "johan-eventos",
        bankAccounts: [
            {
                bankId: "tenpo",
                name: "Luis Briceño",
                bank: "Banco prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111127039052",
                dni: "RUT: 27039052-8",
                ticketPrice: "20000 CLP",
                ticketPriceAmount: 20000,
                ticketCurrency: "CLP"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Luis Colmenares',
                accountNumber: "2108876813",
                ticketPrice: "$20 dólar",
                ticketPriceAmount: 20,
                ticketCurrency: "USD"
            },
            {
                bankId: "bancodevenezuela",
                 name: "Lisbeth Zambrano",
                 dni: "Cédula: V-16410596",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Ahorro",
                 accountNumber: "01020150180100085246",
                 ticketPrice: "2800BS",
                 ticketPriceAmount: 2800,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 140,
                     dolarPriceCurrency: "BS",
                 }
             },
        ]
    },
    {
        accountId: "mono-lokura",
        bankAccounts: [
            {
                bankId: 'bancodevenezuela',
                name: "Maria Duque",
                dni: "Cédula: V-30.138.662",
                bank: "Banco de Venezuela🇻🇪",
                accountNumber: "-",
                phone: "04120310186",
                accountType: "Pago móvil",
                ticketPrice: "150Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Nicole Maza',
                accountNumber: "adriannycorrales6@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                name: "Alba Peinado",
                accountNumber: "3043326205",
                ticketPrice: "$5000 COP",
                ticketPriceAmount: 5000,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "los-primos",
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                 name: "Banco de Venezuela",
                 dni: "Cédula: V28.472.471",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04124677322",
                 ticketPrice: "2$ o 270bs",
                 ticketPriceAmount: 270,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 135,
                     dolarPriceCurrency: "BS",
                 }
             },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Felix Pérez',
                dni: 'Mínima compra 5 tickets. Añadir número de confirmación completo.',
                accountNumber: "felixdanielperezcrespo17012005@gmail.com",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'cash',
                bank: "Efectivo",
                name: 'Efectivo',
                address: 'Santa Cruz Del Este',
                ticketPrice: "2$ o 270bs",
                ticketPriceAmount: 270,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 135,
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    }, 
    {
        accountId: "el-viejo",
        bankAccounts: [
            {
                bankId: "bancofalabella",
                name: "Leonela Maria Marquez",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "1-602-008335-0",
                dni: "RUT: 28.118.393-1",
                ticketPrice: "500 CLP",
                ticketPriceAmount: 500,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'santander',
                name: "Multiservicios El Viejo Spa",
                dni: "Rut: 77.949.638-4",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "0-000-9472564-0",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    }, 
    {
        accountId: "not-licencia-process",
        bankAccounts: [
            {
                bankId: "tenpo",
                name: "Joel Falcon",
                bank: "Banco prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111127898840",
                dni: "RUT: 27898840-6",
                ticketPrice: "1000 CLP",
                ticketPriceAmount: 1000,
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Joel David Falcon",
                dni: "Rut: 27898840-6",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1067993728",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    }, 
    {
        accountId: "rifa-loca",
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                 name: "Yaneisy Mendoza",
                 dni: "Cédula: V2078233-2",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "0412-2957895",
                 ticketPrice: "57.5BS",
                 ticketPriceAmount: 57.5,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 115,
                     dolarPriceCurrency: "BS",
                 }
             },
            {
                bankId: "yape",
                name: "Rosybel Inés",
                bank: "Yape",
                accountType: "Yape",
                accountNumber: "-",
                phone: '+51930337267',
                ticketPrice: "4 SOL",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Yonel Diaz',
                dni: 'Colocar en concepto: Pago rifa',
                accountNumber: "yoneldiaztv144@gmail.com",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Paypal",
                dni: 'Colocar en concepto: Pago rifa',
                accountNumber: "yoneltv14@gmail.com",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'cashapp',
                bank: "Cash App",   
                name: "Yonel Diaz",
                accountNumber: "+1 609-533-4195",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Yanelys Mendoza",
                accountNumber: "myanelys15@gmail.com",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "the-show-2001",
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-29.548.121",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04129906953',
                ticketPrice: "280Bs",
                ticketPriceAmount: 280,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "bci",
                name: "Ybrain Parra",
                dni: "RUT: 27.899.063-K",
                bank: "Banco BCI🇨🇱",
                accountNumber: "777927899063",
                phone: "+56932837376",
                accountType: "Cuenta Corriente",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP",
            },
            {
                bankId: 'santander',
                name: "Jose Diaz Lopez",
                dni: "Rut: 27.521.566-K",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "0-056-27-52156-6",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Binance",
                accountNumber: "bonyfer.02@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Paypal",
                accountNumber: "diazmicael2001@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    }, 
     {
        accountId: 'yoiber-mota',
        bankAccounts: [
            {
                name: "Banco de Venezuela",
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.773.196",
                bank: "Banco de Venezuela 🇻🇪",
                accountNumber: "04129356630",
                accountType: "Pago Móvil",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: 'https://yourbankwebsite-chile.com',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
     {
        accountId: 'bendecidos-con-villa',
        bankAccounts: [
            {
                name: "Banco de Venezuela",
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.046.771",
                bank: "Banco de Venezuela 🇻🇪",
                accountNumber: "04244431231",
                accountType: "Pago Móvil",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: 'https://yourbankwebsite-chile.com',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Correo villaluisjo@gmail.com",
                accountNumber: "Binance ID: 442951208",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'zinli',
                bank: "Zinli",
                name: "Luis Villa",
                accountNumber: "villaluisjo@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'plin',
                name: 'Plin',
                bank: "Perú 🇵🇪",
                dni: "Plin: +51 958 453 566",
                accountNumber: '+51 958 453 566',
                ticketPrice: "$4 soles",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            },
            {
                bankId: 'zelle',
                accountNumber: 'bendecidosconvilla@gmail.com',
                bank: "Zelle (compra minima 10 tickets)",
                name: 'A demanda',
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "fsm-rifas",
        bankAccounts: [
            {
                name: 'Daisy Rangel',
                bankId: 'provincial',
                dni: "Cédula: V-19.456.263",
                bank: "Provincial 🇻🇪",
                accountNumber: '01080281410100290226',
                accountType: "Cuenta Corriente",
                ticketPrice: "120Bs",
                ticketPriceAmount: 120,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Daisy Rangel',
                bankId: 'provincial',
                dni: "Cédula: V-19.456.263",
                bank: "Provincial 🇻🇪",
                accountNumber: '-',
                phone: '04248179139',
                accountType: "Pago móvil",
                ticketPrice: "120Bs",
                ticketPriceAmount: 120,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Daisy Rangel',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-19.456.263",
                bank: "Banco de Venezuela 🇻🇪",
                accountNumber: '-',
                phone: '04248169425',
                accountType: "Pago móvil",
                ticketPrice: "120Bs",
                ticketPriceAmount: 120,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Francisco Medina',
                accountNumber: "fran190619@gmail.com",
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Binance",
                accountNumber: "Binance ID: 1135204821",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "flow-exotico",
        bankAccounts: [
          {
                bankId: "banesco",
                 name: "Banesco",
                 dni: "Cédula: V13.846.461",
                 bank: "Banesco 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04125900070",
                 ticketPrice: "2$ o 1040bs",
                 ticketPriceAmount: 1040,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 130,
                     dolarPriceCurrency: "BS",
                 }
             },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Ynrri Monagas',
                dni: 'Mínima compra 5 tickets. Añadir número de confirmación completo.',
                accountNumber: "+14709474837",
                address: "yymonagas@gmail.com",
                ticketPrice: "$8 dólares",
                ticketPriceAmount: 8,
                ticketCurrency: "USD"
            },

            {
                bankId: 'binance',
                bank: "Binance",
                name: "AMMLR",
                accountNumber: "Binance ID: 1045479308",
                ticketPrice: "$8 dólares",
                ticketPriceAmount: 8,
                ticketCurrency: "USD"
            },
            {
                bankId: 'wise',
                bank: "Wise",
                name: "MARIANNY Montilla BE38905542236572",
                accountNumber: "Swift/bic: TRWIBEB1XXX",
                ticketPrice: "$8 euros",
                ticketPriceAmount: 8,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bizum',
                bank: "Bizum 🇪🇸",
                name: 'Miguel Cardenas',
                accountNumber: '+34642386426',
                ticketPrice: "$8 euros",
                ticketPriceAmount: 8,
                ticketCurrency: "USD"
            },
            
        ]
    }, 
    {
        accountId: "rifas-jh-blessd",
        bankAccounts: [
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Leonardo Largo',
                accountNumber: "leonardolargo530@gmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-26.227.473",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04241984364',
                ticketPrice: "280Bs",
                ticketPriceAmount: 280,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 280, 
                    dolarPriceCurrency: "BS",
                }
            },
              {
                bankId: 'bancolombia',
                bank: "Bancolombia 🇨🇴",
                accountType: 'Ahorro',
                name: "Miller Castellanos",
                accountNumber: "614-671559-29",
                ticketPrice: "$10000 COP",
                ticketPriceAmount: 10000,
                ticketCurrency: "USD"
            },
            
        ]
    }, 
    {
        accountId: "rifas-el-largo",
        bankAccounts: [
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Leonardo Largo',
                accountNumber: "leonardolargo530@gmail.com",
                ticketPrice: "$0,75 dólares",
                ticketPriceAmount: 0.75,
                ticketCurrency: "USD"
            },
            {
                name: 'Provincial',
                bankId: 'provincial',
                dni: "Cédula: V-20.283.530",
                bank: "Provincial",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04246870372',
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
              {
                bankId: 'bancolombia',
                bank: "Bancolombia 🇨🇴",
                accountType: 'Ahorro',
                name: "Keily Coromoto Ruiz Rojas",
                accountNumber: "47776607378",
                ticketPrice: "$10000 COP",
                ticketPriceAmount: 10000,
                ticketCurrency: "USD"
            },
            
        ]
    }, 
    {
        accountId: "brotherifas",
        bankAccounts: [
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'MICHAEL SOLÓRZANO BRAVO',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "maichimo3114@hotmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-27.359.181",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04242045941',
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Ñeco VnPR",
                accountNumber: "Binance ID: 382837755",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Paypal",
                accountNumber: "@victorperez619402",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'nickel',
                bank: "Nickel",   
                accountNumber: "ES1068930001710000244745",
                name: 'Rafael Alejandro Brizuela',
                ticketPrice: "$1 euro",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "el-del-puerto-rifas",
        bankAccounts: [ 
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-18.345.753",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04120339692',
                ticketPrice: "250Bs",
                ticketPriceAmount: 250,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 125, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Juan Carlos Sanchez',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "juancarlossanchezramirez17@gmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bizum',
                bank: "Bizum 🇪🇸",
                name: 'Diego Orta',
                accountNumber: 'ES8501820901680202367446',
                phone: '685089641',
                ticketPrice: "$2 euros",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "rifas-el-charro",
        bankAccounts: [ 
            {
                name: 'Yorman Mora',
                bankId: 'provincial',
                dni: "Cédula: V-25.154.485",
                bank: "Provincial 🇻🇪",
                accountNumber: '01080115030100120653',
                accountType: "Cuenta Corriente",
                ticketPrice: "248Bs",
                ticketPriceAmount: 248,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 165, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Yeimar Solano',
                accountNumber: "yeimarsolano05@gmail.com",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Yorman Mora",
                accountNumber: "yormaanms@gmail.com ",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "gordoloto",
        bankAccounts: [
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Kendri Tejada',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "kendrieliastejada@gmail.com",
                ticketPrice: "$10 dólares",
                ticketPriceAmount: 10,
                ticketCurrency: "USD"
            },
            {
                name: 'YOSIANA YANAIRT MOSQUERA BRUTUA',
                bankId: 'bancogeneralpanama',
                bank: "Banco General - 🇵🇦",
                accountType: "Cuenta de Ahorro",
                accountNumber: '0439970623690',
                ticketPrice: "10Bs",
                ticketPriceAmount: 10,
                href: '-',
                ticketCurrency: "USD",
            },
            { 
                bankId: 'banreservas',
                name: "LUISA FERNANDA BOLIVAR S",
                dni: "Pasaporte: 168713066",
                bank: "Banco Banreservas 🇩🇴",
                accountType: "Cuenta Ahorro",
                accountNumber: "9604477321",
                ticketPrice: "602 pesos",
                ticketPriceAmount: 602,
                href: '-',
                ticketCurrency: "DOP"
            },
            { 
                bankId: 'bancoestado',
                name: "Kelvis Tejada",
                dni: "Rut: 27.908.418-7",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27908418",
                ticketPrice: "10000 pesos",
                ticketPriceAmount: 10000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Paypal",
                accountNumber: "kendryelitejada0505@gmail.com",
                ticketPrice: "$10 dólares",
                ticketPriceAmount: 10,
                ticketCurrency: "USD"
            },
        ]
    }, 
    {
        accountId: "alejandro-el-gochito",
        bankAccounts: [
            { 
                bankId: 'bancoestado',
                name: "Jose Alejandro Alfonso Valencia",
                dni: "Rut: 27146773-7",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27146773",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Daniela Delgado',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "danny15624@gmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: "bancodevenezuela",
                 name: "Jose Alejandro Valencia",
                 dni: "Cédula: V26.515.946",
                 bank: "Banco de Venezuela 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04125004519",
                 ticketPrice: "250BS",
                 ticketPriceAmount: 250,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 125,
                     dolarPriceCurrency: "BS",
                 }
             },
            {
                bankId: 'mercadopago',
                name: "Mariaeugenia Carrizo",
                dni: "Rut: 264638488",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1004572315",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: "rifas-chente",
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-9.781.530",
                bank: "Banco de Venezuela",
                accountType: "Cuenta Corriente",
                accountNumber: '01020145490001284524',
                ticketPrice: "150Bs",
                ticketPriceAmount: 150,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Edward Ferrer',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "713-380-1002",
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancoestado',
                name: "José Cárdenas",
                dni: "Rut: 27.769.669-K",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27769669",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            // {
            //     bank: "Zelle 🇻🇪 🇺🇸",
            //     name: "venezwindows@gmail.com",
            //     accountType: "Adjuntar comprobante completo",
            //     ticketPrice: "$1 dólar",
            //     ticketPriceAmount: 1,
            //     ticketCurrency: "USD"
            // },
        ]
    },
    {
        accountId: "gana-con-laurys",
        bankAccounts: [
            {
                bankId: "mercantil",
                name: 'Mercantil',
                dni: "Cédula: V-21.115.120",
                bank: "Banco Mercantil",
                accountNumber: "-",
                phone: "04248248246",
                accountType: "Pago Móvil",
                ticketPrice: "135Bs",
                ticketPriceAmount: 135,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 135, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Laurys Villasana',
                accountNumber: "lauryvillasanasalas@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "gana-con-juancho",
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-23.944.940",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04242859273',
                ticketPrice: "35Bs",
                ticketPriceAmount: 35,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: "angel-hernandez",
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-27.904.728",
                bank: "Banco de Venezuela",
                accountType: "Pago Movil",
                accountNumber: '-',
                phone: '041229598314',
                ticketPrice: "112Bs",
                ticketPriceAmount: 112,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 112, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Zelle',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "militziett3007@gmail.com",
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "dilan-grau",
        bankAccounts: [
            {
                name: "Zulisbeth Manzo",
                dni: "Rut: 27.160.802-0",
                bankId: "bancochile",
                bank: "Banco de Chile 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "00-027-76210-69",
                ticketPrice: "600 pesos",
                ticketPriceAmount: 600,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: 'Zulisbeth Manzo',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-18.707.277",
                bank: "Banco de Venezuela",
                accountType: "Cuanta ahorro",
                accountNumber: '01020226480100015225',
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'binance',
                bank: "Binance",   
                name: "Binance",
                accountNumber: "Binance ID: 141436702",
                ticketPrice: "$0.6 dólar",
                ticketPriceAmount: 0.6,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        
        accountId: "rifas-el",
        bankAccounts: [
            
            {
                bankId: 'mercadopago',
                name: "Solanyer Cano",
                dni: "Rut: 27045960-9",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1011671681",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: "Juan",
                dni: "Rut: 24731038-k",
                bankId: "bancochile",
                bank: "Banco de Chile 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "000250620300",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: 'Ellery Urdaneta',
                bankId: 'provincial',
                dni: "Cédula: V-5.507.067",
                bank: "Banco Provincial",
                accountType: "Cuanta Ahorro",
                accountNumber: '0108 0327 6102 0010 0229',
                phone: '0414-251-3857',
                ticketPrice: "205Bs",
                ticketPriceAmount: 205,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    },
    {
        accountId: "moto-transformer",
        bankAccounts: [
        {
            name: 'Banesco',
            bankId: 'banesco',
            dni: "Cédula: J-316759997",
            bank: "Banesco",
            accountType: "Corriente",
            accountNumber: '01340443764431020824',
            ticketPrice: "570Bs",
            ticketPriceAmount: 570,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 190, 
                dolarPriceCurrency: "BS",
            }
        },   
        {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: J-316759997",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04242003446',
                ticketPrice: "570Bs",
                ticketPriceAmount: 570,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 190, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                accountNumber: '7282002010',
                bank: "Zelle",
                name: 'Michele Senigaglia',
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "ecko-joyas",
        bankAccounts: [
            {
                name: 'Angie Morales',
                bankId: 'provincial',
                dni: "Cédula: V-21.085.033",
                bank: "Banco Provincial",
                accountType: "Cuanta ahorro",
                accountNumber: '-',
                phone: '0414-251-3857',
                ticketPrice: "500Bs",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Angie Morales",
                accountNumber: "angiemoralesp10@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'zelle',
                accountNumber: 'ydmlr.29@gmail.com',
                bank: "Zelle (mínima compra 5 tickets)",
                name: 'Johana López',
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",   
                name: "Angie Morales",
                accountNumber: "angiemoralesp10@gmail.com",
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'nequi',
                name: "Aylin Medina",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "3127083381",
                ticketPrice: "10000 pesos",
                ticketPriceAmount: 10000,
                href: '-',
                ticketCurrency: "COP"
            },

        ]
    },
    {
        accountId: "suena-en-grande",
        bankAccounts: [
            {
                name: 'Miguel Figueredo',
                bankId: 'bancaribe',
                dni: "Cédula: V-30.225.870",
                bank: "Bancaribe",
                accountType: "Pago Movil",
                accountNumber: '-',
                phone: '04242041058',
                ticketPrice: "115",
                ticketPriceAmount: 115,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                accountNumber: '-',
                bank: "Zelle",
                name: 'Raikarina Montano',
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "wild-life-rescue",
        bankAccounts: [
            {
                name: 'Bancamiga',
                bankId: 'bancaamiga',
                dni: "Cédula: V-19.445.482",
                bank: "Bancamiga 🇻🇪",
                phone: "04149089751",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "575Bs",
                ticketPriceAmount: 575,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'bancolombia',
                name: "Juan Pablo Bermeo García",
                // dni: "Cédula: 1.0007.877.596",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "70665330999",
                ticketPrice: "20000 pesos",
                ticketPriceAmount: 20000,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                bankId: 'zelle',
                accountNumber: '-',
                bank: "Zelle",
                name: 'A demanda',
                dni: "Escribir al whatsapp de soporte",
                ticketPrice: "$5 dólar",
                ticketPriceAmount: 5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",   
                name: "Josmely Cabrera Rescue",
                accountNumber: "135503289",
                ticketPrice: "$5 dólar",
                ticketPriceAmount: 5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "Josmely Cabrera",
                accountNumber: "josmely2030@gmail.com",
                address: "(usar la calculadora de PayPal, la comisión deberá cubrirla el emisor)",
                ticketPrice: "$5 dólar",
                ticketPriceAmount: 5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'yape',
                name: 'Josmely Cabrera ',
                bank: 'Yape',
                accountNumber: "940805262",
                ticketPrice: "$20 soles",
                ticketPriceAmount: 20,
                ticketCurrency: "SOL"
            },
            {
                bankId: 'bcp',
                name: 'Josmely Cabrera',
                bank: 'BCP',
                accountType: "Ahorros",
                accountNumber: "19103470758015",
                ticketPrice: "$20 soles",
                ticketPriceAmount: 20,
                ticketCurrency: "SOL"
            },
        ]
    },
    {
        accountId: "ganamos-con-antoni",
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-19.272.362",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04242095501',
                ticketPrice: "90Bs",
                ticketPriceAmount: 90,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 90, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'BDT',
                bankId: 'bdt',
                dni: "Cédula: V-20.537.710",
                bank: "BDT",
                accountType: "Pago Móvil",
                accountNumber: '-',
                phone: '04125371421',
                ticketPrice: "90Bs",
                ticketPriceAmount: 90,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 90, 
                    dolarPriceCurrency: "BS",
                },
                hide: true
            },
        ]
    },
    {
        accountId: "oscar-alarcon",
        bankAccounts: [
            {
                bankId: 'tenpo',
                name: "Diana Medina",
                dni: "Rut: 19879108-3",
                bank: "Banco Prepago Tenpo",
                accountType: "Cuenta Vista",
                accountNumber: "111119879108",
                ticketPrice: "2500 pesos",
                ticketPriceAmount: 2500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Oscar Donato Alarcon",
                dni: "Rut: 27.591.242-5",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1030647762",
                ticketPrice: "2500 pesos",
                ticketPriceAmount: 2500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancoestado',
                name: "Oscar Alarcon",
                dni: "Rut: 27.591.242-5",
                bank: "Banco Estado",
                accountType: "Cuenta Corriente",
                accountNumber: "00100416484",
                ticketPrice: "2500 pesos",
                ticketPriceAmount: 2500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancoestado',
                name: "Oskarli Alarcon",
                dni: "Rut: 27.848.017-8",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27848017",
                ticketPrice: "2500 pesos",
                ticketPriceAmount: 2500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "oscaralarcon048@gmail.com",
                accountNumber: "941714665",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",   
                name: "Oscar Alarcon",
                accountNumber: "941714665",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'plin',
                name: 'Plin',
                bank: "Perú 🇵🇪",
                dni: "Plin: 928821360",
                accountNumber: '928821360',
                ticketPrice: "$10 soles",
                ticketPriceAmount: 10,
                ticketCurrency: "SOL"
            },
            {
                bankId: 'bancodevenezuela',
                name: "Jiselh Andreina Rojas Ariza",
                dni: "Cédula: V-28.24.74.25",
                bank: "Banco de Venezuela",
                accountNumber: "01020180220000286015",
                phone: '+58 0412-5183750',
                accountType: "Cuenta Corriente",
                ticketPrice: "250bs",
                ticketPriceAmount: 250,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 101,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                accountNumber: '-',
                bank: "Zelle",
                name: 'A demanda',
                dni: "Escribir al whatsapp de soporte",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "goyo2time",
        bankAccounts: [
            {
                name: "Jose Luque",
                dni: "Rut: 26.525.588-4",
                bankId: "bancochile",
                bank: "Banco de Chile 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "00-015-57222-15",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: "Yence Macero",
                dni: "Cédula: V-6.825.769",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountNumber: "0134 0215 9421 5105 4891",
                accountType: "Cuenta Corriente",
                ticketPrice: "86Bs",
                ticketPriceAmount: 86,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 47.55,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: "Jose Luque",
                dni: "RUT: 26.525.588-4",
                bank: "Banco Estado🇨🇱",
                accountNumber: "26525588",
                accountType: "Cuenta RUT",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP",
            },
            {
                name: "Jose Luque",
                dni: "RUT: 26.525.588-4",
                bank: "Banco BCI🇨🇱",
                accountNumber: "777926525588",
                accountType: "Cuenta Corriente",
                ticketPrice: "2000 CLP",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP",
            },
            {
                name: "Michael Dominguez",
                bank: "Zelle 🇻🇪 🇺🇸",
                accountNumber: "3214404791",
                dni: "piruetasmk@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "gana-con-luxury",
        bankAccounts: [
            {
                name: "Ricardo Alvarado",
                dni: "Cédula: V-28.354.581",
                bankId:  "banesco",
                bank: "Banesco",
                accountNumber: "01341203100001008188",
                accountType: "Cuenta Corriente",
                ticketPrice: "210Bs",
                ticketPriceAmount: 210,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: "Ricardo Alvarado",
                dni: "Cédula: V-28.354.581",
                bankId:  "banesco",
                bank: "Banesco",
                accountNumber: "-",
                phone: "0424-5104969",
                accountType: "Pago Móvil",
                ticketPrice: "210Bs",
                ticketPriceAmount: 210,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140,
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "zelle",
                name: "Alexandra Rojas",
                bank: "Zelle 🇻🇪 🇺🇸",
                accountNumber: "509 987 8050",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "anthony-flow",
        bankAccounts: [
           {
                bankId: "bancodevenezuela",
                name: 'Pago Móvil',
                dni: "Cédula: V-27.173.916",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04122239484",
                ticketPrice: "29Bs",
                ticketPriceAmount: 29,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 121, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'bancoestado',
                name: "Priscilla Morales",
                dni: "Rut: 27.086.548-8",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27086548",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "zelle",
                name: "Luis Rivero",
                bank: "Zelle 🇻🇪 🇺🇸",
                accountNumber: "+12164182377",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "maikel-dominguez",
        bankAccounts: [
            {
                bankId: "mercadopago",
                name: "Oscar Alarcon",
                dni: "Rut: 27.591.242-5",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1030647762",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "zelle",
                name: "Michael Dominguez",
                bank: "Zelle 🇻🇪 🇺🇸",
                accountNumber: "3214404791",
                dni: "michaeliriarte315@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "bancodevenezuela",
                name: 'Pago Móvil',
                dni: "Cédula: V-25.327.420",
                bank: "Banco de Venezuela",
                accountNumber: "04123868075",
                ticketPrice: "104Bs",
                ticketPriceAmount: 104,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 104, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "paypal",
                name: 'Paypal',
                bank: "Paypal",
                accountNumber: "piruetasmk@gmail.com",
                dni: "piruetasmk@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            // {
            //     name: "Franklin Mera Rios",
            //     dni: "Cédula: 0962434452",
            //     bank: "Ecuador 🇪🇨",
            //     accountType: "Cuenta Corriente",
            //     accountNumber: "28255866",
            //     ticketPrice: "1 USD",
            //     ticketPriceAmount: 1,
            //     href: '-',
            //     ticketCurrency: "USD"
            // },
            
        ]
    },  
    {
        accountId: 'rifa-sport',
        bankAccounts: [
            {
                bankId: 'tenpo',
                name: "Diana Medina",
                dni: "Rut: 19879108-3",
                bank: "Banco Prepago Tenpo",
                accountType: "Cuenta Vista",
                accountNumber: "111119879108",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'mercadopago',
                name: "Oscar Donato Alarcon",
                dni: "Rut: 27.591.242-5",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1030647762",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancoestado',
                name: "Oscar Alarcon",
                dni: "Rut: 27.591.242-5",
                bank: "Banco Estado",
                accountType: "Cuenta Corriente",
                accountNumber: "00100416484",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancoestado',
                name: "Oskarli Alarcon",
                dni: "Rut: 27.848.017-8",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27848017",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'paypal',
                bank: "Paypal",   
                name: "oscaralarcon048@gmail.com",
                accountNumber: "941714665",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",   
                name: "Oscar Alarcon",
                accountNumber: "941714665",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancolombia',
                name: "Jerson Andrés Alzate Cifuentes",
                dni: "Cédula: 1.0007.877.596",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "912-268373-08",
                ticketPrice: "6200 pesos",
                ticketPriceAmount: 6200,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                bankId: 'bancodevenezuela',
                name: "Jiselh Andreina Rojas Ariza",
                dni: "Cédula: V-28.24.74.25",
                bank: "Banco de Venezuela",
                accountNumber: "01020180220000286015",
                phone: '+58 0412-5183750',
                accountType: "Cuenta Corriente",
                ticketPrice: "120bs",
                ticketPriceAmount: 120,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 80,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'cash',
                bank: "Efectivo",
                name: 'Efectivo',
                dni: "Franklin 200, Santiago - Carhwash El Niño",
                ticketPrice: "$3000 pesos",
                ticketPriceAmount: 3000,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'w-robles',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: 'William Robles',
                dni: "Cédula: V-27.097.189",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04125079684",
                accountType: "Pago Móvil",
                ticketPrice: "60Bs",
                ticketPriceAmount: 60,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    },
    
    {
        accountId: 'rifa-los-primos',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: 'Banco de Venezuela',
                dni: "Cédula: V-21.199.864",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04124881395",
                accountType: "Pago Móvil",
                ticketPrice: "115Bs",
                ticketPriceAmount: 115,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Felix Pérez',
                dni: 'Mínima compra 5 tickets. Añadir número de confirmación completo.',
                accountNumber: "felixdanielperezcrespo17012005@gmail.com",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
        ]
    },
    
    {
        accountId: 'full-diesel',
        bankAccounts: [
            {
                name: 'Gabriel Molina',
                bankId: 'bancaamiga',
                dni: "Cédula: V-22.928.034",
                bank: "Bancamiga 🇻🇪",
                phone: "04242825499",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "1115.19Bs",
                ticketPriceAmount: 1115.19,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115.19, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Luisana Molina",
                bank: "Zelle",
                dni: "fuulldiesel@gmail.com",
                ticketPrice: "$10 dólares",
                ticketPriceAmount: 10,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'grita-caracas',
        bankAccounts: [
            {
                name: 'Bancamiga',
                bankId: 'bancaamiga',
                dni: "Cédula: V-22.760.781",
                bank: "Bancamiga 🇻🇪",
                phone: "04242980179",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "150Bs",
                ticketPriceAmount: 150,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 150, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Shoptoday LLC",
                bank: "Zelle",
                dni: "shoptoday.ve@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'grow-dp',
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-11.158.509",
                bank: "Banesco 🇻🇪",
                phone: "04143097737",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "200Bs",
                ticketPriceAmount: 200,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 200, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "JANCARLOS COLLADO",
                accountNumber: "-",
                phone: "4697408153",
                bank: "Zelle",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'stephanie-luxury',
        bankAccounts: [
           {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-28.053.730",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "04241767255",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPriceCurrency: "BS",
                }
            },    
            {
                bankId: 'yape',
                name: 'Sthefania Obando Castillo',
                bank: 'Yape',
                accountNumber: "957610339",
                ticketPrice: "$4 soles",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            },         
              {
                bankId: 'zelle',
                name: "Junior Hidalgo",
                accountNumber: "hidalgoalexander715@gmail.com",
                bank: "Zelle",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "bcp",
                bank: "Banco Central Peru 🇵🇪",
                accountNumber: "19196959870059",
                name: 'Sthefania Obando Castillo',
                ticketPrice: "5000 sol",
                ticketPriceAmount: 5000,
                href: '-',
                ticketCurrency: "SOL",
            },
            {
                name: 'Mercantil',
                bankId: 'mercantil',
                dni: "Cédula: V-30.349.847",
                bank: "Mercantil 🇻🇪",
                accountNumber: '-',
                accountType: "Pago Móvil",
                phone: '04129689196',
                ticketPrice: "200Bs",
                ticketPriceAmount: 200,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 200, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'plin',
                name: "Sthefania Obando Castillo",
                accountType: 'Yape',
                bank: "Yape Perú 🇵🇪",
                phone: "957610339",
                ticketPrice: "4 soles",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            }
        ]
    },
    {
        accountId: 'gerej-16',
        bankAccounts: [
            {
                "name": "Banco de Venezuela",
                "href": "-",
                "dni": "Cédula: V-28.053.730",
                "bank": "Banco de Venezuela 🇻🇪",
                "accountType": "Pago Móvil",
                "accountNumber": "-",
                "ticketPrice": "105Bs",
                "ticketPriceAmount": 105,
                "ticketCurrency": "BS",
                "conversion": {
                    "dolarPrice": 210,
                    "dolarPriceCurrency": "BS"
                },
                "bankId": "bancodevenezuela",
                "phone": "04241767255"
            },
            {
                "name": "Luis Sanchez",
                "bank": "Zelle",
                "accountNumber": "-",
                "ticketPrice": "$0.50 dólar",
                "ticketPriceAmount": 0.5,
                "ticketCurrency": "USD",
                "conversion": {
                    "dolarPrice": 0,
                    "dolarPriceCurrency": ""
                },
                "bankId": "zelle",
                "phone": "8502764575"
            },
            {
                "name": "CAIXESBBXXX",
                "href": "-",
                "bank": "CaixaBank 🇪🇸",
                "accountNumber": "ES15 2100 6446 8102 0021 7076",
                "ticketPrice": "0.50 euro",
                "ticketPriceAmount": 0.5,
                "ticketCurrency": "USD",
                "conversion": {
                    "dolarPrice": 0,
                    "dolarPriceCurrency": ""
                },
                "bankId": "caixabank"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "Binance ID: 1159070897",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            }
        ]
    },
    {
        accountId: 'rifas-al-dia',
        bankAccounts: [
           {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.541.050",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "04123769159",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "205Bs",
                ticketPriceAmount: 205,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 1,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "Binance ID: eduardodicamb@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            }
           
        ]
    },
    {
        accountId: 'rommy-18',
        bankAccounts: [
            {
                name: 'Ejemplo',
                bankId: 'bancaamiga',
                dni: "Cédula: V-11.111.111",
                bank: "Bancamiga 🇻🇪",
                phone: "1111",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "1Bs",
                ticketPriceAmount: 1,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 1, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Zelle",
                bank: "Zelle",
                dni: "ejemplo@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'b-mendoza',
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.226.027",
                bank: "Bancamiga 🇻🇪",
                phone: "04242178663",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "60Bs",
                ticketPriceAmount: 60,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Rusbel Bello Mendoza",
                bank: "Zelle",
                ticketPrice: "$0.5 dólares",
                accountNumber: "3014019927",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {   
        accountId: 'loto-family',
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.630.031",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "04125746926",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "400Bs",
                ticketPriceAmount: 400,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 200, 
                    dolarPriceCurrency: "BS",
                }
            },        
            {
                name: 'Banco Exterior',
                bankId: 'banco-exterior',
                dni: "Cédula: V-14.756.713",
                bank: "Banco Exterior 🇻🇪",
                phone: "04241180863",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "400Bs",
                ticketPriceAmount: 400,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 200, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Nelson García",
                bank: "Zelle",
                ticketPrice: "$2 dólares",
                accountNumber: "5706561877",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "angigc15@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            }
        ]
    },
    {
        accountId: '2-locos-rifando',
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.758.428",
                bank: "Bando de Venezuela 🇻🇪",
                phone: "04242178663",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "110Bs",
                ticketPriceAmount: 110,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 110, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "marlixm.mm@gmail.com",
                bank: "Zelle (compra minima 7 tickets)",
                accountNumber: "8325636735",
                ticketPrice: "$0.7 dólar",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifa-bera-2025',
        bankAccounts: [
            {
                name: 'Basesco',
                bankId: 'banesco',
                dni: "Cédula: V-25.213.522",
                bank: "Banesco 🇻🇪",
                phone: "04142318535",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "75Bs",
                ticketPriceAmount: 75,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "Binance ID: 137403953",
                ticketPrice: "$0.75 dólar",
                ticketPriceAmount: 0.75,
                ticketCurrency: "USD"
            }
        ]
    },
    {
        accountId: 'tus-rifas-rt',
        bankAccounts: [
            {
                name: 'Basesco',
                bankId: 'banesco',
                dni: "Cédula: V-24.101.061",
                bank: "Banesco 🇻🇪",
                phone: "04128388504",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: "Mercantil",
                href: "-",
                dni: "Cédula: V-6.317.974",
                bank: "Mercantil 🇻🇪",
                accountType: "Pago Móvil",
                accountNumber: "-",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                ticketCurrency: "BS",
                conversion: {
                    "dolarPrice": 100,
                    "dolarPriceCurrency": "BS"
                },
                bankId: "mercantil",
                phone: "04123800081"
            },
            {
                bankId: 'zelle',
                name: "Zelle",
                bank: "Zelle",
                accountNumber: "+1(224)2799476",
                ticketPrice: "$0.50 dólar",
                ticketPriceAmount: 0.50,
                ticketCurrency: "USD"
            },
            {
                name: 'Zinli',
                bankId: 'zinli',
                bank: "Zinli 🇺🇸 ",   
                accountNumber: "dariananatabares@gmail.com",
                ticketPrice: "$0.3 dólar",
                ticketPriceAmount: 0.3,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'gana-con-alonso',
        bankAccounts: [
            {
                bankId: 'tenpo',
                name: "JOEL ALONSO AGUILAR BAUTE",
                dni: "Rut: 27200402-1",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111127200402",
                ticketPrice: "800 pesos",
                ticketPriceAmount: 800,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "mercadopago",
                name: "Jesica Dariana Mendoza Velasquez",
                dni: "Rut: 26451959-4",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1010024794",
                ticketPrice: "800 pesos",
                ticketPriceAmount: 800,
                href: '-',
                ticketCurrency: "CLP"
            },  
            {
                bankId: 'santander',
                name: "Instalaciones Alonso Spa",
                dni: "Rut: 77.456.482-9",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "0-000-8433916-4",
                ticketPrice: "800 pesos",
                ticketPriceAmount: 800,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'zelle',
                name: "Yoorwin Bastidas",
                bank: "Zelle",
                accountNumber: "7793746971",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'el-gran-perrote',
        bankAccounts: [
            {
                bankId: 'santander',
                name: "Asociaciones Angulo Spa",
                dni: "Rut: 77.901.288-3",
                bank: "Banco Santander",
                accountType: "Cuenta Corriente",
                accountNumber: "0-000-9383343-0",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'tenpo',
                name: "GERMAIN ALEXANDER SANTANA CONTRERAS",
                dni: "Rut: 25803715-4",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111125803715",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'binance',
                name: "Binance",
                bank: "Binance 🇺🇸",
                dni: "germainsantana1988@gmail.com",
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancoestado',
                name: "Germain Santana",
                dni: "Rut: 25803715-4",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "25803715",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-15.106.563",
                bank: "Banesco 🇻🇪",
                phone: "04142353386",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "570bs",
                ticketPriceAmount: 570,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    },
    {
        accountId: 'tony-12-grau',
        bankAccounts: [
            {
                name: 'Provincial',
                bankId: 'provincial',
                dni: "Cédula: V-30.188.058",
                bank: "Provincial 🇻🇪",
                phone: "04121637613",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "150Bs",
                ticketPriceAmount: 150,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 150, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "Richard Rivero",
                bank: "Zelle",
                dni: "richard28rivero@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'santander',
                name: "Richard Jose Rivero Cedeno",
                dni: "Rut: 26.976.762-6",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "0 000 81 29827 0",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'rifas-gran-oriente',
        bankAccounts: [ 
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-29.905.719",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "04128429355",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "70Bs",
                ticketPriceAmount: 70,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    },
    {
        accountId: 'gana-con-carlasha',
        bankAccounts: [
            {
                name: 'banesco',
                bankId: 'banesco', 
                dni: "Cédula: V-30.363.104",
                bank: "Banesco",
                phone: "04244536119",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "70Bs",
                ticketPriceAmount: 70,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                name: 'banesco',
                bankId: 'banesco',
                dni: "Cédula: V-31.933.656",
                bank: "Banesco 🇻🇪",
                phone: "04144992985",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "70Bs",
                ticketPriceAmount: 70,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                name: 'banesco',
                bankId: 'banesco',
                dni: "Cédula: V-30.363.104",
                bank: "Banesco 🇻🇪",
                phone: "04144992985",
                accountNumber: '0134-0428-37-4281053207',
                accountType: "Cuenta de Ahorro",
                ticketPrice: "70Bs",
                ticketPriceAmount: 70,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: 'zelle',
                name: "Carlis Marian",
                bank: "Zelle",
                dni: "carlismarian2024@icloud.com",
                ticketPrice: "$0.6 dólar",
                ticketPriceAmount: 0.6,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifas-petare',
        bankAccounts: [
            {
                name: 'Mercantil',
                bankId: 'mercantil',
                dni: "Cédula: V-18.942.177",
                bank: "Mercantil 🇻🇪",
                phone: "04242306470",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "150Bs",
                ticketPriceAmount: 150,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 150, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "Binance ID: 442005627",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            }
            // {
            //     bankId: 'zelle',
            //     name: "Richard Rivero",
            //     bank: "Zelle",
            //     dni: "richard28rivero@gmail.com",
            //     ticketPrice: "$1 dólar",
            //     ticketPriceAmount: 1,
            //     ticketCurrency: "USD"
            // },
        ]
    },
    {
        accountId: 'gana-con-los-compadres',
        bankAccounts: [
            {
                name: 'Mario Moreno',
                bankId: 'banesco',
                dni: "Cédula: V-15.670.267",
                bank: "Mercantil 🇻🇪",
                accountNumber: '01340946330001389567',
                accountType: "Corriente",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 200, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'tenpo',
                name: "MAICOL ANTHONY MORENO MORENO",
                dni: "Rut: 26943226-8",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111126943226",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "mercadopago",
                name: "Maicol Anthony Moreno Moreno",
                dni: "Rut: 26943226-8",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1032862680",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'rifas-jj',
        bankAccounts: [
            {
                name: 'Provincial',
                bankId: 'provincial',
                dni: "Cédula: V-21.140.872",
                bank: "Provincial 🇻🇪",
                phone: "04126701475",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "330Bs",
                ticketPriceAmount: 330,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Jesus Rodriguez",
                bank: "Zelle",
                dni: "jesusanthinai@gmail.com ",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifas-la-botija',
        bankAccounts: [
            {
                name: 'Juan Carlos Ceballos',
                bankId: 'provincial',
                dni: "Cédula: V-13.845.682",
                bank: "Provincial 🇻🇪",
                accountNumber: '0108-0015-30-0100147582',
                accountType: "Cuenta Corriente",
                ticketPrice: "75Bs",
                ticketPriceAmount: 75,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 0.5, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Juan Carlos Ceballos',
                bankId: 'provincial',
                dni: "Cédula: V-13.845.682",
                bank: "Provincial 🇻🇪",
                phone: "04143207120",
                accountNumber: '-',
                accountType: "Pago móvil",
                ticketPrice: "75Bs",
                ticketPriceAmount: 75,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "Juan Ceballos",
                bank: "Zelle",
                dni: "JCEBALLOS79@hotmail.com",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
            bankId: "binance",
            bank: "Binance 🇺🇸",
            name: 'Madiceb',
            accountNumber: "-",
            href: 'JCEBALLOS79@hotmail.com',
            ticketPrice: "$0.5 dólares",
            ticketPriceAmount: 0.5,
            ticketCurrency: "USD"
        }
        ]
    },
    {
        accountId: 'rifas-los-hermanos',
        bankAccounts: [
            {
                name: 'Nelson Uzcátegui',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-33.392.903",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "04241323175",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "130Bs",
                ticketPriceAmount: 130,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 130, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'bancolombia',
                name: "Enderson Gabriel Mora Marquez",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "22569974899",
                ticketPrice: "6500 pesos",
                ticketPriceAmount: 6500,
                href: '-',
                ticketCurrency: "COP"
            },
             {
                bankId: 'zelle',
                name: "7029454920",
                bank: "Zelle",
                dni: "7029454920",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                name: "Nequi",
                accountNumber: "3507313548",
                ticketPrice: "$6500 COP",
                ticketPriceAmount: 6500,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'carlos-pinango',
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-26.140.524",
                bank: "Banesco 🇻🇪",
                phone: "0412-7538368",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "180Bs",
                ticketPriceAmount: 180,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "mercadopago",
                name: "Kevin Yordan Baez Celis",
                dni: "Rut: 27805681-3",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1085590251",
                ticketPrice: "1800 pesos",
                ticketPriceAmount: 1800,
                href: '-',
                ticketCurrency: "CLP"
            },     
             {
                bankId: 'zelle',
                name: "Jesus Rodriguez",
                bank: "Zelle",
                dni: "jesusanthinai@gmail.com ",
                ticketPrice: "$1.8 dólares",
                ticketPriceAmount: 1.8,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'a-donde-la-negra',
        bankAccounts: [
            {
                bankId: "bancoestado",
                name: "All In Exports",
                dni: "Rut: 77.393.021-K",
                bank: "Banco Estado",
                accountType: "Chequera electrónica / Vista",
                accountNumber: "902-7-323205-1",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                name: 'Nelson Uzcátegui',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-14127144",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "0414-6634604",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "60Bs",
                ticketPriceAmount: 60,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 60, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Nelson Uzcátegui',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-14127144",
                bank: "Banco de Venezuela 🇻🇪",
                phone: "0414-6634604",
                accountNumber: '01020501810003272482',
                accountType: "Cuenta Corriente",
                ticketPrice: "60Bs",
                ticketPriceAmount: 60,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 60, 
                    dolarPriceCurrency: "BS",
                }
            },
         {
                bankId: 'santander',
                name: "All in Exports",
                dni: "Rut: 77.393.021-K",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "97679550",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'gana-con-leonardo',
        bankAccounts: [
            {
                name: 'Basesco',
                bankId: 'banesco',
                dni: "Cédula: V-20.154.166",
                bank: "Banesco 🇻🇪",
                phone: "04241831242",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "27Bs",
                ticketPriceAmount: 27,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115.19, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                name: 'Zinli',
                bankId: 'zinli',
                bank: "Zinli 🇺🇸 ",   
                accountNumber: "Lverasilva413@gmail.com",
                ticketPrice: "$0.3 dólar",
                ticketPriceAmount: 0.3,
                ticketCurrency: "USD"
            },
              {
                name: 'Paypal',
                bankId: 'paypal',
                bank: "Paypal",
                accountNumber: "lverasilva413@gmail.com",
                ticketPrice: "$0.3 dólar",
                ticketPriceAmount: 0.3,
                ticketCurrency: "USD"
            },
             {
            bankId: "binance",
            bank: "Binance 🇺🇸",
            name: 'lverasilva413@gmail.com',
            accountNumber: "Binance ID: 900156780",
            ticketPrice: "$0.3 dólares",
            ticketPriceAmount: 0.3,
            ticketCurrency: "USD"
        }
        ]
    },
    {
        accountId: 'alex-vargas',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: 'Alex Vargas',
                dni: "Cédula: V-31.995.226",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04241909742",
                accountType: "Pago Móvil",
                ticketPrice: "50Bs",
                ticketPriceAmount: 50,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Binance',
                bankId: 'binance',
                bank: "Binance 🇺🇸 ",   
                accountNumber: "1043780961",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.50,
                ticketCurrency: "USD"
            }
        ]
    },
    {
        accountId: 'la-buena-racha',
        bankAccounts: []
    },
    {
        accountId: 'hernancito-jr',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: 'Dayarit Contreras',
                dni: "Cédula: V-30.288.055",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04129021972",
                accountType: "Pago Móvil",
                ticketPrice: "115Bs",
                ticketPriceAmount: 115,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'HernancitoJR',
                accountNumber: "Binance ID: 463736766",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
             {
                bankId: 'zelle',
                name: "Zelle",
                bank: "Zelle",
                dni: "barriosannerys316@gmail.com",
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'yape',
                name: 'Ronny Garcia',
                bank: 'Yape',
                accountNumber: "902186174",
                ticketPrice: "$4 soles",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            },
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                name: "Luz Marina Velez Pelea",
                accountNumber: "3042457563",
                ticketPrice: "$4000 COP",
                ticketPriceAmount: 4000,
                ticketCurrency: "USD"
            },
            {
                bankId: 'tenpo',
                name: "ZULAY REYES LIZCANO",
                dni: "Rut: 26883865-1",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111126883865",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'rifas-tj',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: 'Banco de Venezuela',
                dni: "Cédula: V-20.794.567",
                bank: "Banco de Venezuela",
                accountNumber: "-",
                phone: "04127945042",
                accountType: "Pago Móvil",
                ticketPrice: "115Bs",
                ticketPriceAmount: 115,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: 'zelle',
                name: "jose Daniel polo montes",
                bank: "Zelle",
                dni: "773-970-4249",
                href: 'josepolo01032022@gmail.com',
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                name: "jose Daniel  polo montes",
                accountNumber: "3165059253",
                ticketPrice: "$4000 COP",
                ticketPriceAmount: 4000,
                ticketCurrency: "USD"
            },
            {
                bankId: 'tenpo',
                name: "FRANCISCO VIDAL CARDONA LIENDO",
                dni: "Rut: 26175349-9",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111126175349",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'la-guaira-market',
        bankAccounts: [
            {
                bankId: 'bancodevenezuela',
                name: 'Banco Venezuela',
                dni: "Cédula: V-27.225.859",
                bank: "Banco Venezuela",
                accountNumber: "-",
                phone: "04242024830",
                accountType: "Pago Móvil",
                ticketPrice: "230Bs",
                ticketPriceAmount: 230,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 230, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                name: "Salyn Terkmani",
                bank: "Zelle",
                accountNumber: "7866570785",
                ticketPrice: "1 usd",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                name: "Salyn Terkmani",
                bank: "Binance",
                dni: "salynterkmani311@gmail.com",
                ticketPrice: "1 usd",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            }
            ]

    },
    {
        accountId: 'ale-jef',
        bankAccounts: [
            {
                bankId: "mercantil",
                name: 'Mercantil',
                dni: "Cédula: V-29.861.036",
                bank: "Banco Mercantil",
                accountNumber: "-",
                phone: "04120247036",
                accountType: "Pago Móvil",
                ticketPrice: "50Bs",
                ticketPriceAmount: 50,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'rifas-los-chacaros',
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V27114840",
                bank: "Banco de Venezuela",
                accountNumber: "04162785275",
                accountType: "Pago Móvil",
                ticketPrice: "480Bs",
                ticketPriceAmount: 480,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 240, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "Carolina Duran",
                bank: "Zelle",
                accountNumber: 'carolinadurvar@gmail.com',
                dni: "vegas10@hotmal.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Diego Vazquez',
                accountNumber: "Binance ID: andruduran95@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancolombia',
                name: "Andru Enrique Duran Molina",
                dni: 'Cédula de ciudadanía pasaporte: 174868101',
                bank: "Bancolombia",
                phone: "3219041121",
                accountType: "Cuenta de Ahorro",
                accountNumber: "82400008991",
                ticketPrice: "8000 pesos",
                ticketPriceAmount: 8000,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                bankId: 'bancoestado',
                name: "José Gregorio Molina Duran",
                dni: "Rut: 26297719-6",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "262977196",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            }, 
            {
                bankId: "bizum",
                bank: "Bizum 🇪🇸 (Colocar el nombre en la referencia)",
                name: 'Miguel Angel Devia',
                accountNumber: '610048394',
                ticketPrice: "$2 euro",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'buenaventura',
        bankAccounts: [
            {
                bankId: "banesco",
                name: 'Banesco',
                dni: "Cédula: V-17.959.003",
                bank: "Banco Banesco",
                accountNumber: "-",
                phone: "04145819620",
                accountType: "Pago Móvil",
                ticketPrice: "300Bs",
                ticketPriceAmount: 300,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "banesco",
                name: 'Banesco',
                dni: "Cédula: V-17.959.003",
                bank: "Banco Banesco",
                accountNumber: "01341089510001005998",
                accountType: "Cuenta Corriente",
                ticketPrice: "300Bs",
                ticketPriceAmount: 300,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'santander',
                name: "Feliz Vegas",
                dni: "Rut: 25.938.561-K",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "0-000-93-89680-7",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'zelle',
                name: "Rifas Buenaventura",
                bank: "Zelle",
                dni: "vegas10@hotmal.com",
                ticketPrice: "$3 dólares",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'victor-arteaga',
        bankAccounts: [
            {
                bankId: 'bancoestado',
                name: "VICTOR DAVID ARTEAGA ROJAS",
                dni: "Rut: 26593128-6",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "26593128",
                ticketPrice: "4000 pesos",
                ticketPriceAmount: 4000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "bancofalabella",
                name: "Luisana BRITO",
                dni: "Rut: 28.113.034-K",
                bank: "Banco Falabella",
                accountType: "Banco Falabella",
                accountNumber: "19801666877",
                ticketPrice: "4000 pesos",
                ticketPriceAmount: 4000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "mercadopago",
                name: "Loreli Urdaneta",
                dni: "Rut: 27.826.366-5",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1068702422",
                ticketPrice: "4000 pesos",
                ticketPriceAmount: 4000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Víctor Arteaga',
                accountNumber: "Binance ID: 723539708",
                ticketPrice: "$4 dólar",
                ticketPriceAmount: 4,
                ticketCurrency: "USD"
            }
        ]
    },
    {
        accountId: 'tu-gran-sueno',
        bankAccounts: [
            {
                bankId: "bancaamiga",
                name: 'Bancamiga',
                dni: "Cédula: V-27.769.151",
                bank: "Banco Banesco",
                accountNumber: "-",
                phone: "04127137930",
                accountType: "Pago Móvil",
                ticketPrice: "240Bs",
                ticketPriceAmount: 240,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 240, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "Luis Guacaran",
                bank: "Zelle",
                dni: "6023304955",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                name: 'Luis Guacaran',
                bankId: 'paypal',
                bank: "Paypal",
                accountNumber: "Luis Guacaran",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifas-oriente',
        bankAccounts: [
            {
                bankId: 'zelle',
                bank: "Zelle",
                dni: "9515058025",
                name: 'Anderson Colon',
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancoestado',
                name: "Luis Carlos Lopez Escalona",
                dni: "Rut: 26158783-1",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "26158783",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                bankId: 'banesco',
                name: 'Banesco',
                dni: "Cédula: V-24.513.303",
                bank: "Banesco - 0134 🇻🇪 Pago Móvil",
                accountNumber: '04148439871',
                ticketPrice: "240Bs",
                ticketPriceAmount: 240,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 86, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'el-rifazo',
        bankAccounts: [
            {
                bankId: "bancofalabella",
                name: "Jairo Jose Morales Villalobos",
                dni: "Rut: 26.608.948-1",
                bank: "Mercado Pago",
                accountType: "Banco Falabella",
                accountNumber: "11600073530",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                bankId: "mercadopago",
                name: "Lianyeling del Carmen Morales Villalobos",
                dni: "Rut: 27.415.074-2",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1067782566",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                bankId: "santander",
                name: "Jairo Jose Morales Villalobos",
                dni: "Rut: 26.608.948-1",
                bank: "Banco Santander",
                accountType: "Cuenta Corriente",
                accountNumber: "000086937816",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                bankId: "bancoestado",
                name: "Jairo Morales",
                dni: "Rut: 26.608.948-1",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "26.608.948",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },     
            {
                bankId: "banesco",
                name: "Ángel Villalobos",
                dni: "Cédula: V-15.069.878",
                bank: "Banesco",
                accountType: "Cuenta Corriente",
                accountNumber: '0134-0449-6844-9103-4133',
                ticketPrice: "230Bs",
                ticketPriceAmount: 230,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "banesco",
                name: "Ángel Villalobos",
                dni: "Cédula: V-15.069.878",
                bank: "Banesco",
                accountType: "Pago Móvil",
                accountNumber: '-',
                ticketPrice: "230Bs",
                phone: "04246436481",
                ticketPriceAmount: 230,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 115, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Paypal',
                bankId: 'paypal',
                bank: "Paypal",
                accountNumber: "jairomvillalobos@gmail.com",
                phone: "942225076",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'zelle',
                bank: "Zelle",
                name: 'A demanda',
                dni: "Escribir al whatsapp de soporte",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'luis-bigrau',
        bankAccounts: [
            {
                name: 'Banco Mercantil',
                dni: "Cédula: V-20.489.389",
                bank: "Banco Mercantil 🇻🇪",
                accountNumber: "04261871035",
                accountType: "Pago Móvil",
                ticketPrice: "40Bs",
                ticketPriceAmount: 40,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 86, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: "Luis Delgado",
                bank: "Zelle",
                dni: "Ld864808@gmail.com",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bank: "Bizum 🇪🇸",
                name: 'Jhondaiver Daniel Alvarez Ponte',
                accountNumber: '613368445',
                ticketPrice: "$0.5 euro",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'ruedas-extremas',
        bankAccounts: [
            {
                bankId: 'bancaribe',
                name: 'Ban Caribe 0114',
                dni: "Cédula: V-18.957.171",
                bank: "Ban Caribe",
                accountNumber: "-",
                phone: '04144791105',
                accountType: "Pago Móvil",
                ticketPrice: "101Bs",
                ticketPriceAmount: 101,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 101, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                name: "Kevin Valdespino",
                bank: "Zelle",
                dni: "fabianvaldespino7@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancofalabella',
                name: "Yinderson Gonzalez",
                dni: "Rut: 27.576.928-2",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "1-519-011940-7",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'lobo-guarenas',
        bankAccounts: [{
            bankId: 'bancodevenezuela',
            name: 'Banco Venezuela',
            dni: "Cédula: V-19.354.014",
            bank: "Banco Venezuela",
            accountNumber: "-",
            phone: "04126878581",
            accountType: "Pago Móvil",
            ticketPrice: "130Bs",
            ticketPriceAmount: 130,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 130, 
                dolarPriceCurrency: "BS",
            }
        },
        {
            bankId: 'zelle',
            name: "Edinson Guaita",
            bank: "Zelle",
            dni: "5137393216",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        }]
    },
    {
        accountId: 'dj-tito',
        bankAccounts: [{
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-30.164.811",
                bank: "Banesco 🇻🇪",
                accountNumber: "04125126220",
                accountType: "Pago Móvil",
                ticketPrice: "200Bs",
                ticketPriceAmount: 200,
                href: '-',
                ticketCurrency: "BS",
            }]
    },
    {
        accountId: 'ultra-ganador',
        bankAccounts: [{
            bankId: 'zelle',
            bank: "Zelle",
            name: 'Steve Wu Wu',
            accountNumber: "+1 (832) 347-9187",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },{
            bankId: "bancofalabella",
            name: "Orlando GALINDO",
            bank: "Banco Falabella 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "19999137530",
            dni: "RUT: 27.238.706-0",
            ticketPrice: "1000 CLP",
            ticketPriceAmount: 1000,
            ticketCurrency: "CLP"
        },{
                bankId: "bizum",
                name: "Gerahr Padilla Torres",
                bank: "Bizum 🇪🇸",
                accountNumber: '+34 613 96 61 40',
                ticketPrice: "$1 euro",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },{
            bankId: 'bancodevenezuela',
            name: 'Banco Venezuela',
            dni: "Cédula: V-28.408.002",
            bank: "Banco Venezuela",
            accountNumber: "-",
            phone: "04143705541",
            accountType: "Pago Móvil",
            ticketPrice: "180Bs",
            ticketPriceAmount: 180,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 180, 
                dolarPriceCurrency: "BS",
            }
        },
        {
            bankId: "binance",
            bank: "Binance 🇺🇸",
            name: 'Diego Vazquez',
            accountNumber: "Binance ID: 574109718",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },{
            name: 'Nequi',
            bankId: 'nequi',
            bank: "Nequi",
            accountNumber: "302 229 74 08",
            ticketPrice: "5000 COP",
            ticketPriceAmount: 5000,
            ticketCurrency: "COP"
        }]
    },
    {
        accountId: 'yilson-grau',
        bankAccounts: [{
            bankId: 'bancodevenezuela',
            name: 'Banco Venezuela',
            dni: "Cédula: V-26.473.291",
            bank: "Banco Venezuela",
            accountNumber: "-",
            phone: "04129508292",
            accountType: "Pago Móvil",
            ticketPrice: "130Bs",
            ticketPriceAmount: 130,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 130, 
                dolarPriceCurrency: "BS",
            }
        },
        {
            name: 'Binance',
            bankId: 'binance',
            bank: "Binance 🇺🇸 ",   
            accountNumber: "1008848148",
            href: 'cr8341257@gmail.com',
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },
        {
            bankId: 'zelle',
            bank: "Zelle",
            name: 'Corporacion1060',
            accountNumber: "corporacionmdjr25@gmail.com",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        }]
    },
    {
        accountId: 'rifas-lmg',
        bankAccounts: [{
            bankId: 'bancodevenezuela',
            name: 'Dalieska  Velásquez',
            dni: "Cédula: V-29.981.894",
            bank: "Banco Venezuela",
            accountNumber: "-",
            phone: "04124327299",
            accountType: "Pago Móvil",
            ticketPrice: "180Bs",
            ticketPriceAmount: 180,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 120, 
                dolarPriceCurrency: "BS",
            }
        },
        {
            bankId: 'zelle',
            name: "Weinder Gil",
            bank: "Zelle",
            accountNumber: '9177953037',
            ticketPrice: "$1.5 dólar",
            ticketPriceAmount: 1.5,
            ticketCurrency: "USD"
        },
        {
            name: 'Paypal',
            bankId: 'paypal',
            bank: "Paypal",
            accountNumber: "weinderlyn@gmail.com",
            ticketPrice: "$1.5 dólar",
            ticketPriceAmount: 1.5,
            ticketCurrency: "USD"
        }]
    },
    {
        accountId: 'rifas-los-chamos',
        bankAccounts: [{
            name: 'Banco de Venezuela',
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-21.376.140",
            bank: "Banco de Venezuela",
            accountNumber: "04124750655",
            accountType: "Pago Móvil",
            ticketPrice: "101Bs",
            ticketPriceAmount: 101,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 101, 
                dolarPriceCurrency: "BS",
            }
        },
        {
            bankId: 'santander',
            name: "La Latina Spa",
            dni: "Rut: 77.962.798-5",
            bank: "Banco Santander 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "0-000-9475058-0",
            ticketPrice: "1000 pesos",
            ticketPriceAmount: 1000,
            href: '-',
            ticketCurrency: "CLP"
        },
        {
            bankId: 'zelle',
            bank: "Zelle (compra minima 10 tickets)",
            name: 'Danger Franco Izaguirre',
            accountNumber: "7868218823",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },
        {
            name: 'Binance',
            bankId: 'binance',
            bank: "Binance 🇺🇸 ",   
            accountNumber: "1043780961",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        }]
    },
    {
        accountId: 'gana-con-ibelles',
        bankAccounts: [
        {
            bankId: "bancofalabella",
            name: "Adriannys",
            bank: "Banco Falabella 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "1593007156",
            dni: "RUT: 27.314.158-8",
            ticketPrice: "500 CLP",
            ticketPriceAmount: 500,
            ticketCurrency: "CLP"
        },
        {
            bankId: 'santander',
            name: "Luis Ibelles Colina Perez",
            dni: "Rut: 27.631.921-3",
            bank: "Banco Santander 🇨🇱",
            accountType: "Cuenta Corriente",
            accountNumber: "0 000 87 26111 5",
            ticketPrice: "1000 pesos",
            ticketPriceAmount: 1000,
            href: '-',
            ticketCurrency: "CLP"
        },
        {
            bankId: 'bancoestado',
            name: "Ana Mary Bermejo",
            dni: "Rut: 27.631.921-3",
            bank: "Banco Estado",
            accountType: "Cuenta RUT",
            accountNumber: "27631921",
            ticketPrice: "3000 pesos",
            ticketPriceAmount: 3000,
            href: '-',
            ticketCurrency: "CLP"
        }]
    },
    {
        accountId: 'rifas-deluxe',
        bankAccounts: [
            {
                bankId: 'zelle',
                name: "Jhonny Aleta",
                bank: "Zelle",
                dni: "jhonnyaleta@gmail.com",
                ticketPrice: "$30 dólar",
                ticketPriceAmount: 30,
                ticketCurrency: "USD"
            },
            {
                name: 'Bancamiga',
                bankId: 'bancaamiga',
                dni: "Cédula: V-30.887.253",
                bank: "Bancamiga 🇻🇪",
                phone: "04242395832",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "3000Bs",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Binance',
                bankId: 'binance',
                bank: "Binance 🇺🇸 ",   
                accountNumber: "alvarogabrieltorrado@gmail.com",
                ticketPrice: "$30 dólar",
                ticketPriceAmount: 30,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'punto-alto-ikigai',
        bankAccounts: [
            {
                name: 'vade.tengue.LEMON',
                bankId: 'lemoncash',
                bank: "Lemon Cash",   
                accountNumber: "0000168300000021078815",
                ticketPrice: "$3000 pesos argentinos",
                ticketPriceAmount: 3000,
                ticketCurrency: "ARG"
            },
            {
                name: 'Marx Rangel',
                bankId: 'cuentanaranja',
                bank: "Cuenta Naranja ",   
                accountNumber: "4530000800018253401895",
                ticketPrice: "$3000 pesos argentinos",
                ticketPriceAmount: 3000,
                ticketCurrency: "ARG"
            },
              {
                bankId: 'zelle',
                name: "Wilmer Mejicano",
                bank: "Zelle",
                dni: "wilmer5477@gmail.com",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                name: 'Marx Rangel',
                bankId: 'binance',
                bank: "Binance 🇺🇸 ",   
                accountNumber: "marx_75k@hotmail.com",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'monino',
        bankAccounts: [{
            name: 'Banco de Venezuela',
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-31.396.299",
            bank: "Banco de Venezuela",
            phone: "04120874686",
            accountType: "Pago Móvil",
            ticketPrice: "70Bs",
            ticketPriceAmount: 70,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 0, 
                dolarPriceCurrency: "BS",
            }
        },{
            bankId: 'zelle',
            name: "willy Escalona",
            bank: "Zelle",
            dni: "4077151894",
            ticketPrice: "$0.5 dólar",
            ticketPriceAmount: 0.5,
            ticketCurrency: "USD"
        },]
    },
    {
        accountId: 'franyer-jar',
        bankAccounts: [{
            name: 'Franyeli Vianca Bolivar Castrillon',
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-30.553.250",
            bank: "Banco de Venezuela",
            phone: "04120874686",
            accountNumber: "01020264700000207489",
            accountType: "Cuenta Corriente",
            ticketPrice: "40Bs",
            ticketPriceAmount: 40,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 100, 
                dolarPriceCurrency: "BS",
            }
        },   {
            bankId: "binance",
            bank: "Binance 🇺🇸",
            name: 'Daniels Mendoza',
            accountNumber: "Binance ID: 119387146",
            ticketPrice: "$0.4 dólares",
            ticketPriceAmount: 0.4,
            ticketCurrency: "USD"
        }]
    },
    {
        accountId: 'flow-shop',
        bankAccounts: [{
            name: 'Eduardo Cisneros',
            bankId: 'zinli',
            bank: "Zinli 🇺🇸 ",   
            accountNumber: "eduardocisneros555@gmail.com",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },
        {
            bankId: 'zelle',
            bank: "Zelle",
            name: 'Alejandra Nessi',
            accountNumber: "alejandra.nessi@gmail.com",
            ticketPrice: "$1 dólar",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },
        {
            name: "Banco de Venezuela - Pago Móvil",
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-26.476.661",
            bank: "Banco de Venezuela",
            phone: "04241542999",
            accountNumber: "01020264700000207489",
            accountType: "Cuenta Corriente",
            ticketPrice: "100Bs",
            ticketPriceAmount: 100,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 100, 
                dolarPriceCurrency: "BS",
            }
        },   {
            bankId: "binance",
            bank: "Binance 🇺🇸",
            name: 'hypestreetvenezuela@gmail.com',
            accountNumber: "Binance ID: 399325872",
            ticketPrice: "$1 dólares",
            ticketPriceAmount: 1,
            ticketCurrency: "USD"
        },]
    },
    {
        accountId: 'rifas-jf',
        bankAccounts: [{
            name: 'Banco de Venezuela',
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-29.951.542",
            bank: "Banco de Venezuela",
            accountType: "Cuenta Corriente",
            accountNumber: '01020551490000040646',
            ticketPrice: "50Bs",
            ticketPriceAmount: 50,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 100, 
                dolarPriceCurrency: "BS",
            }
        },{
            name: 'Banco de Venezuela',
            bankId: 'bancodevenezuela',
            dni: "Cédula: V-29.951.542",
            bank: "Banco de Venezuela",
            phone: "04141502241",
            accountType: "Pago Móvil",
            ticketPrice: "50Bs",
            ticketPriceAmount: 50,
            href: '-',
            ticketCurrency: "BS",
            conversion: {
                dolarPrice: 100, 
                dolarPriceCurrency: "BS",
            }
        },]
    },
    {
        accountId: 'lotofer',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: "Banco de Venezuela",
                dni: "Cédula: J-504.804.126",
                bank: "Banco de Venezuela",
                accountNumber: "04121396647",
                accountType: "Pago Móvil",
                ticketPrice: "100Bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                bank: "Zelle (compra minima 10 tickets)",
                name: 'Camila Espinoza',
                accountNumber: "camila.espinoza0609@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'emmanuel-dograu',
        bankAccounts: [
            {
                bankId: "bancodevenezuela",
                name: "Banco de Venezuela",
                dni: "Cédula: 30.312.005",
                bank: "Banco de Venezuela",
                phone: "04128938113",
                accountNumber: "-",
                accountType: "Pago Móvil",
                ticketPrice: "30Bs",
                ticketPriceAmount: 30,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                bank: "Zelle (compra minima 10 tickets)",
                name: 'Jeremy Torrealba',
                accountNumber: "jeremytorrealba029@gmail.com",
                phone: '5855521116',
                ticketPrice: "$0.3 dólar",
                ticketPriceAmount: 0.3,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'zpremio',
        bankAccounts: [
            {
                bankId: 'zelle',
                bank: "Zelle (compra minima 10 tickets)",
                name: 'Kevin Rodríguez',
                accountNumber: "edgarantonio@gmail.com",
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Moises Velasques',
                accountNumber: "-",
                href: 'moises.velasques2002@gmail.com',
                ticketPrice: "$3 dólares",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: "mercadopago",
                bank: "Mercado Pago 🇦🇷",
                name: 'Noesito',
                accountNumber: "CVU: 0000003100057960698723",
                ticketPrice: "$3600 ARS",
                ticketPriceAmount: 3600,
                ticketCurrency: "ARS"
            },
            {
                bankId: "pichincha",
                bank: "Pichincha 🇪🇨",
                name: 'Banco Pichincha 🇪🇨',
                accountType: "Cuenta de ahorro transaccional",
                accountNumber: "2210172940",
                ticketPrice: "$3 USD",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancoestado',
                name: "Ana Mary Bermejo",
                dni: "Rut: 28170238-6",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "28170238",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-25.841.797",
                bank: "Banesco 🇻🇪",
                accountNumber: "04144763877",
                accountType: "Pago Móvil",
                ticketPrice: "330Bs",
                ticketPriceAmount: 330,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 110, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'el-mono',
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-12345678",
                bank: "Banesco 🇻🇪",
                accountNumber: "123456678",
                accountType: "Pago Móvil",
                ticketPrice: "330Bs",
                ticketPriceAmount: 330,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 110, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                bank: "Zelle (compra minima 10 tickets)",
                name: 'Zelle',
                accountNumber: "zelle@gmail.com",
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Binance',
                accountNumber: "-",
                href: 'binance@gmail.com',
                ticketPrice: "$3 dólares",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'jj-platinum',
        bankAccounts: [
            {
                name: 'Banco Exterior',
                bankId: 'banco-exterior',
                dni: "Cédula: V-10.576.704",
                bank: "Banco Exterior",
                accountNumber: "-",
                phone: "04165778508",
                accountType: "Pago Móvil",
                ticketPrice: "200Bs",
                ticketPriceAmount: 200,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                bank: "Zelle",
                name: 'Jose Angel Collado',
                accountNumber: "josealozano1999@gmail.com",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'caja-social',
                bank: "Banco Caja Social",
                name: 'Joel Jose Sanchez Ramirez',
                accountNumber: "24132490621",
                accountType: 'Ahorro',
                ticketPrice: "$10000 pesos",
                ticketPriceAmount: 10000,
                ticketCurrency: "USD"
            },
            {
                bankId: 'cash',
                bank: "Efectivo",
                address: 'A consultar',
                name: 'Efectivo',
                ticketPrice: "2 dolares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'una-vision',
        bankAccounts: [
            {
                name: 'Banco De Venezuela - Pago Móvil',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-28.540.181",
                accountNumber: "-",
                phone: "04120504684",
                ticketPrice: "240Bs",
                ticketPriceAmount: 240,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Miguel Bracamonte',
                dni: 'Mínima compra 4 tickets. Añadir número de confirmación completo.',
                accountNumber: "miguel.marmo26@gmail.com",
                ticketPrice: "$2.5 dólares",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'Una Vision R',
                dni: 'Mínima compra 4 tickets. Añadir número de confirmación completo.',
                accountNumber: "Binance ID: 1105972097",
                ticketPrice: "$2.5 dólares",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'el-nay',
        bankAccounts: [
            {
                name: 'Banco De Venezuela - Pago Móvil',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-22.550.260",
                accountNumber: "-",
                phone: "04244537327",
                ticketPrice: "140Bs",
                ticketPriceAmount: 140,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 140, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Jhoanny Álvarez',
                accountNumber: "7869859987",
                ticketPrice: "$1 dólares",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance 🇺🇸",
                name: 'er637108@gmail.com',
                dni: 'Mínima compra 4 tickets. Añadir número de confirmación completo.',
                accountNumber: "Binance ID: 886322008",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: "bizum",
                name: "Bizum",
                bank: "Bizum 🇪🇸",
                accountNumber: '643560879',
                ticketPrice: "$1 euro",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                name: 'Elvis jose Johan Ruiz García',
                bankId: 'paypal',
                bank: "Paypal",
                accountNumber: "ruizelvis625@gmail.com ",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'la-rifa-del-exito',
        bankAccounts: [
           {
                bankId: "mercantil",
                name: 'Mercantil',
                dni: "Cédula: V-17.561.667",
                bank: "Banco Mercantil",
                accountNumber: "-",
                phone: "04122863391",
                accountType: "Pago Móvil",
                ticketPrice: "420Bs",
                ticketPriceAmount: 420,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 120, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'jgr1',
        bankAccounts: [
            {
                name: 'Banesco',
                bankId: 'banesco',
                dni: "Cédula: V-27.156.018",
                bank: "Banesco 🇻🇪",
                accountNumber: "04120536464",
                accountType: "Pago Móvil",
                ticketPrice: "150Bs",
                ticketPriceAmount: 150,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'nequi',
                bank: "Nequi 🇨🇴",
                name: "JHO** CAR**",
                accountNumber: "3202896779",
                ticketPrice: "$6500 COP",
                ticketPriceAmount: 6500,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancolombia',
                name: "Bancolombia",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "08800018658",
                ticketPrice: "6500 pesos",
                ticketPriceAmount: 6500,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                name: 'Binance',
                bankId: 'binance',
                bank: "Binance 🇺🇸 ",   
                accountNumber: "1020668193",
                ticketPrice: "$1.5 dólares",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "bizum",
                name: "Albert Miranda",
                bank: "Bizum 🇪🇸",
                accountNumber: '602543096',
                ticketPrice: "$1.5 euros",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'zelle',
                bank: "Zelle",
                name: 'Lainet Ortega',
                accountNumber: "(801) 634-4293",
                ticketPrice: "$1.5 dólar",
                ticketPriceAmount: 1.5,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bci',
                dni: "RUT: 26.464.092-K",
                name: "Kenji Hasegawa",
                accountType: "Cuenta Vista",
                bank: "BCI/MACH 🇨🇱",
                accountNumber: "777026464092",
                ticketPrice: "1500 pesos",
                ticketPriceAmount: 1500,
                href: '-',
                ticketCurrency: "CLP",
            },
        ]
    },
    {
        accountId: 'rifas-jonaiker',
        bankAccounts: [
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-30.691.948",
                bank: "Banesco 🇻🇪",
                accountNumber: "04128263712",
                accountType: "Pago Móvil",
                ticketPrice: "60Bs",
                ticketPriceAmount: 60,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'motor-luck',
        bankAccounts: [
            {
                bankId: 'tenpo',
                name: "Clever Fernandez",
                dni: "Rut: 26962052-8",
                bank: "Banco Prepago Tenpo 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "111126962052",
                ticketPrice: "1200 pesos",
                ticketPriceAmount: 1200,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                name: 'Banco de Venezuela',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-18.564.518",
                bank: "Banco de Venezuela",
                accountNumber: '04147060268',
                accountType: 'Pago Móvil',
                ticketPrice: "110Bs",
                ticketPriceAmount: 110,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 89, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'Binance',
                bankId: 'binance',
                bank: "Binance 🇺🇸 ",   
                accountNumber: "393620915",
                ticketPrice: "$1.2 dólar",
                ticketPriceAmount: 1.2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'scotiabank',
                bank: "BBVA - España 🇪🇸",   
                accountNumber: "ES82 0182 5322 2402 0374 9203",
                name: 'Aleanger Vielma',
                accountType: 'Corriente',
                ticketPrice: "$1.1 euro",
                ticketPriceAmount: 1.1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'bancolombia',
                name: "Anderson Tobón Cardona",
                dni: "Cédula: 1.0007.877.596",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "816-515565-11",
                ticketPrice: "5400 pesos",
                ticketPriceAmount: 5400,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                bankId: 'bancolombia',
                name: "Anderson Tobón Cardona",
                dni: "Cédula: 1.0007.877.596",
                bank: "Bancolombia",
                accountType: "Cuenta de Ahorro",
                accountNumber: "816-515565-11",
                ticketPrice: "5400 pesos",
                ticketPriceAmount: 5400,
                href: '-',
                ticketCurrency: "COP"
            },
        ]
    },
    {
        accountId: 'rifas-naguara',
        bankAccounts: [
                {
                    bankId: 'bancodevenezuela',
                    name: 'Banco de Venezuela',
                    dni: "Cédula: V-20.925.858",
                    bank: "Banco de Venezuela",
                    accountNumber: '04245568388',
                    ticketPrice: "490Bs",
                    ticketPriceAmount: 490,
                    href: '-',
                    ticketCurrency: "BS",
                    conversion: {
                        dolarPrice: 98, 
                        dolarPriceCurrency: "BS",
                    }
                },
                {
                    name: 'Paypal',
                    bankId: 'paypal',
                    bank: "Paypal",
                    dni: "jesusanthinai@gmail.com",
                    accountNumber: "333460265817",
                    ticketPrice: "$5 dólar",
                    ticketPriceAmount: 5,
                    ticketCurrency: "USD"
                },
                {
                    bankId: 'bancoestado',
                    name: "Xavier Martinez",
                    dni: "Rut: 27.078.811-4",
                    bank: "Banco Estado 📲",
                    accountType: "Cuenta RUT",
                    accountNumber: "00027078811",
                    ticketPrice: "5000 pesos",
                    ticketPriceAmount: 5000,
                    href: '-',
                    ticketCurrency: "CLP"
                },
                {
                    name: 'Nequi',
                    bankId: 'nequi',
                    bank: "Nequi",
                    accountNumber: "3226937886",
                    ticketPrice: "$20000 COP",
                    ticketPriceAmount: 20000,
                    ticketCurrency: "USD"
                },
                {
                    bankId: 'zelle',
                    bank: "Zelle",
                    name: 'Jesus Rodriguez',
                    accountNumber: "jesusanthinai@gmail.com",
                    ticketPrice: "$5 dólar",
                    ticketPriceAmount: 5,
                    ticketCurrency: "USD"
                },
                {
                    bankId: 'yape',
                    name: 'Yape',
                    bank: 'Yape',
                    accountNumber: "+51 993 349 274",
                    ticketPrice: "$20 soles",
                    ticketPriceAmount: 20,
                    ticketCurrency: "USD"
                }
        ]
    },
    {
        accountId: 'antoni-contreras',
        bankAccounts: [
                {
                    name: 'Antoni Contreras',
                    dni: "Cédula: V-31.243.539",
                    bank: "BFC - 0151 🇻🇪 Pago Móvil",
                    accountNumber: '04248404632',
                    ticketPrice: "102Bs",
                    ticketPriceAmount: 102,
                    href: '-',
                    ticketCurrency: "BS",
                    conversion: {
                        dolarPrice: 102, 
                        dolarPriceCurrency: "BS",
                    }
                },
                {
                    bankId: 'bancolombia',
                    name: "Lismar Mendez",
                    bank: "Bancolombia",
                    accountType: "Cuenta de Ahorro",
                    accountNumber: "82400009131",
                    ticketPrice: "4000 pesos",
                    ticketPriceAmount: 4000,
                    href: '-',
                    ticketCurrency: "COP"
                },
                {
                    bank: "Zelle",
                    name: 'Emely Baca',
                    dni: "6309974211",
                    ticketPrice: "$1 dólar",
                    ticketPriceAmount: 1,
                    ticketCurrency: "USD"
                },
                {
                    name: 'Antoni Contreras',
                    bank: "Binance",
                    accountNumber: "751618875",
                    ticketPrice: "$1 dólar",
                    ticketPriceAmount: 1,
                    ticketCurrency: "USD"
                },
        ]
    },
    {
        accountId: 'el-barines',
        bankAccounts: [
                {
                    name: 'Rifas El Barines',
                    dni: "Cédula: V-25.399.716",
                    bank: "Banco de Venezuela",
                    accountNumber: '04249312121',
                    ticketPrice: "198Bs",
                    ticketPriceAmount: 198,
                    href: '-',
                    ticketCurrency: "BS",
                    conversion: {
                        dolarPrice: 99, 
                        dolarPriceCurrency: "BS",
                    }
                },
                {
                    name: "Nelson Jose Angulo Rojo",
                    dni: "Rut: 25.982.697-7",
                    bank: "Mercado Pago 📲",
                    accountType: "Cuenta Vista",
                    accountNumber: "1035819395",
                    ticketPrice: "2000 pesos",
                    ticketPriceAmount: 2000,
                    href: '-',
                    ticketCurrency: "CLP"
                },
                {
                    name: 'Rifas El Barines',
                    bank: "Binance",
                    accountNumber: "501399085",
                    ticketPrice: "$2 dólar",
                    ticketPriceAmount: 2,
                    ticketCurrency: "USD"
                },
        ]
    },
    {
        accountId: 'white-lion',
        bankAccounts: [
            {
                name: 'Cuenta Zelle',
                bankId: 'zelle',
                bank: "Zelle",
                accountNumber: "avyoha91@gmail.com",
                ticketPrice: "$12 dólar",
                ticketPriceAmount: 12,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'los-ninos',
        bankAccounts: [
            {
                bankId: 'mercadopago',
                name: "Carlos Enrique Perez Romero",
                dni: "Rut: 27.133.027-8",
                bank: "Mercado Pago",
                accountType: "Cuenta Vista",
                accountNumber: "1033254572",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'santander',
                name: "Grismel Katlesca Tovar Lozada",
                dni: "Rut: 27.117.243-5",
                bank: "Banco Santander 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "000097032998",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'bancoestado',
                name: "Valeria Capote Martinez",
                dni: "Rut: 27.136.812-7",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27136812",
                ticketPrice: "3000 pesos",
                ticketPriceAmount: 3000,
                href: '-',
                ticketCurrency: "CLP"
            },
            { 
                name: 'Cuenta BDV',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-12.453.843",
                bank: "Banco De Venezuela - Pago Móvil",
                accountNumber: "04264117955",
                ticketPrice: "3 dólares ó 300Bs",
                ticketPriceAmount: 300,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'zelle',
                bank: "Zelle",
                name: 'A demanda',
                dni: "Escribir al whatsapp de soporte",
                ticketPrice: "$3 dólar",
                ticketPriceAmount: 3,
                ticketCurrency: "USD"
            },
            {
                bankId: 'cash',
                bank: "Efectivo",
                name: 'Efectivo',
                dni: "Franklin 200, Santiago - Carhwash El Niño",
                ticketPrice: "$3000 pesos",
                ticketPriceAmount: 3000,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifas-roalis',
        bankAccounts: [
            { 
                name: 'Cuenta BDV',
                bankId: 'bancodevenezuela',
                dni: "Cédula: V-19.523.141",
                bank: "Banco De Venezuela - Pago Móvil",
                accountNumber: "-",
                phone: "04121314692",
                ticketPrice: "0.4 dólares ó 40Bs",
                ticketPriceAmount: 40,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100,
                    dolarPriceCurrency: "BS",
                }
            }, 
            {
                name: 'Banco De Los Trabajadores',
                bankId: 'bdt',
                bank: "Banco De Los Trabajadores",
                dni: "Cédula: V-20.769.451",
                accountNumber: "04123550461",
                accountType: "Pago Móvil",
                ticketPrice: "0.4 dólares ó 40Bs",
                ticketPriceAmount: 40,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 100,
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'minas-de-baruta',
        bankAccounts: [
            {
                bankId: "mercantil",
                name: 'Cuena Banco Mercantil',
                dni: "Cédula: V-18.714.122",
                bank: "Banco Mercantil - Pago Móvil 🇻🇪",
                accountNumber: "04120218723",
                ticketPrice: "0.5 dólar ó 65Bs",
                ticketPriceAmount: 65,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 130,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle",
                name: 'Carlos Cruzco',
                dni: "carloscruzco23@gmail.com",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "paypal",
                bank: "Paypal",
                name: 'Carlos Cruzco',
                dni: "@carloszahir023",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "bancodeguayaquil",
                bank: "Banco: Guayaquil 🇪🇨",
                accountType: 'Cuenta de Ahorro',
                accountNumber: "#0028255866",
                name: 'Franklin Mera',
                ticketPrice: "0.5 dólares",
                ticketPriceAmount: 0.5,
                href: '-',
                ticketCurrency: "USD",
            },
          
            {
                bankId: "caixabank",
                bank: "CaixaBank 🇪🇸",
                accountNumber: "ES15 2100 6446 8102 0021 7076",
                name: 'CAIXESBBXXX',
                ticketPrice: "0.5 dólares",
                ticketPriceAmount: 0.5,
                href: '-',
                ticketCurrency: "USD",
            },
            {
                bankId: "bancofalabella",
                name: "Yesenia Leiva",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "19831617394",
                dni: "RUT: 19055818-5",
                ticketPrice: "500 CLP",
                ticketPriceAmount: 500,
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'vip-rifas',
        bankAccounts: [
            {
                name: 'Vip Rifas',
                dni: "Cédula: V-26.901.703",
                bank: "Banco Venezuela - Pago Móvil 🇻🇪",
                accountNumber: "04241982696",
                ticketPrice: "3 dólar ó 121,77Bs",
                ticketPriceAmount: 121.77,
                href: '-',
                ticketCurrency: "BS",
            },
        ]
    },
    {
        accountId: 'jhonfrank-cordero',
        bankAccounts: [            
            {
                bankId: "bnc",
                 name: "Banco Nacional De Crédito",
                 dni: "Cédula: V29.502.378",
                 bank: "Banco Nacional De Crédito 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04129385708",
                 ticketPrice: "500bs",
                 ticketPriceAmount: 500,
                 href: '-',
                 ticketCurrency: "BS",
                 conversion: {
                     dolarPrice: 200,
                     dolarPriceCurrency: "BS",
                 }
             },
             {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Anderson Camejo',
                dni: 'camejoenderson134@gmail.com',
                accountNumber: "8652964226",
                ticketPrice: "$2.5 dólar",
                ticketPriceAmount: 2.5,
                ticketCurrency: "USD"
            },
            {
                name: "Franyesi Camejo",
                bank: "Yape",
                dni: "CCI: 00219119506602909054",
                accountNumber: "19195066029090",
                phone: "973 949 531",
                ticketPrice: "8 soles",
                ticketPriceAmount: 8,
                ticketCurrency: "PEN",
                bankId: "yape"
            },
        ]
    },
    {
        accountId: 'rifas-11-11',
        bankAccounts: [            
            {
                name: 'LUIS RONALD, PAIVA GARCES',
                bankId: 'bancaamiga',
                dni: "Cédula: V-25.531.988",
                bank: "Bancamiga 🇻🇪",
                phone: "04142431435",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "490Bs",
                ticketPriceAmount: 490,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 245, 
                    dolarPriceCurrency: "BS",
                }
            },
            {
                name: 'LUIS RONALD, PAIVA GARCES',
                bankId: 'bancaamiga',
                dni: "Cédula: V-25.531.988",
                bank: "Bancamiga 🇻🇪",
                accountNumber: '01720112361126119450',
                accountType: "Cuenta Corriente",
                ticketPrice: "490Bs",
                ticketPriceAmount: 490,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 245, 
                    dolarPriceCurrency: "BS",
                }
            },
        ]
    },
    {
        accountId: 'sobre-ruedas-ok',
        bankAccounts: [
            {
                name: "Flavia Lino De Casteo",
                bank: "Mercado pago",
                accountNumber: "CVU: 0000003100095307843148 Alias: flavia96",
                ticketPrice: "3500 ARS",
                ticketPriceAmount: 3500,
                ticketCurrency: "ARS",
                bankId: "mercadopago"
            },
            {
                name: "Motosamar",
                bank: "Binance",
                accountNumber: "Binance ID: 1081055697",
                ticketPrice: "$2.60 dólar",
                ticketPriceAmount: 2.6,
                ticketCurrency: "USDT",
                bankId: "binance"
            },
            {
                name: "Deibys Xavi Pizarro Rodriguez",
                dni: "deibys1@gmail.com",
                bank: "Zelle",
                ticketPrice: "$2.60 dólares",
                ticketPriceAmount: 2.6,
                ticketCurrency: "USD",
                bankId: "zelle"
            },
            {
                name: "ABDELEYKA MARTINS",
                dni: "RUT: 26967414-8",
                bank: "TAPP Caja Los Andes",
                accountType: "Cuenta Vista",
                accountNumber: "26967414",
                ticketPrice: "2500 CLP",
                ticketPriceAmount: 2500,
                ticketCurrency: "CLP",
                bankId: "tapp"
            },
            {
                name: "Isabel Aguilar de Jimenez",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountType: "Pago móvil",
                accountNumber: "04241338843",
                dni: "C.I.: 25369664",
                ticketPrice: "450 BS",
                ticketPriceAmount: 450,
                ticketCurrency: "BS",
                bankId: "banesco"
            },
            {
                name: "Soporte de pagos",
                bank: "Payway",
                accountNumber: "—",
                phone: "+5491138046983",
                ticketPrice: "3500",
                ticketPriceAmount: 3500,
                ticketCurrency: "",
                bankId: "payway"
            }
        ]
    },
    {
        accountId: 'gana-con-johnbi',
        bankAccounts: [
            {
                name: 'Baneso',
                bankId: 'banesco',
                dni: "Cédula: V-16.299.489",
                bank: "Banesco - Pago Móvil 🇻🇪",
                accountType: "Pago Móvil",
                accountNumber: "-",
                phone: "04248516605",
                ticketPrice: "100bs",
                ticketPriceAmount: 100,
                href: '-',
                ticketCurrency: "BS",
            },
            {
                bankId: "zelle",
                bank: "Zelle",
                name: 'Zelle',
                dni: "jjmarques2611@gmail.com",
                ticketPrice: "$0.7 dólar",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifalo-ya',
        bankAccounts: [
            {
                name: "Luis Mosquera Somaza",
                bank: "PayPal",
                accountNumber: "contacto@sortealoyaoficial.com",
                ticketPrice: "$0.70 dólares",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USD",
                bankId: "paypal"
            },
            {
                name: "-",
                bank: "Bancolombia",
                accountType: "Cuenta de ahorros",
                accountNumber: "76971584960",
                ticketPrice: "700 COP",
                ticketPriceAmount: 700,
                ticketCurrency: "COP",
                bankId: "bancolombia"
            },
            {
                name: "-",
                bank: "Nequi",
                accountType: "Billetera",
                accountNumber: "3246240995",
                ticketPrice: "700 COP",
                ticketPriceAmount: 700,
                ticketCurrency: "COP",
                bankId: "nequi"
            },
            {
                name: "Miguel Ángel Chávez",
                bank: "Yape",
                accountNumber: "+51 959 521 896",
                phone: "+51 959 521 896",
                ticketPrice: "2.50 soles",
                ticketPriceAmount: 2.5,
                ticketCurrency: "PEN",
                bankId: "yape"
            },
            {
                name: "luis aaron kurt mosquera somaza",
                bank: "Wise",
                accountType: "Checking",
                accountNumber: "211991840651",
                phone: "101019628",
                ticketPrice: "$0.70 dólares",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USD",
                bankId: "wise"
            },
            {
                name: "Charlin Casamayor Palencia",
                bank: "Banco de Venezuela",
                accountType: "Cuenta Corriente",
                accountNumber: "01020864550000724195",
                dni: "V-23570397",
                ticketPrice: "150 BS",
                ticketPriceAmount: 150,
                ticketCurrency: "BS",
                bankId: "bancodevenezuela"
            },
            {
                name: "Charlin Casamayor Palencia",
                bank: "Pago Móvil BDV",
                accountType: "Pago móvil",
                accountNumber: "04162441607",
                dni: "Cédula: V23570397",
                ticketPrice: "150 BS",
                ticketPriceAmount: 150,
                ticketCurrency: "BS",
                bankId: "bancodevenezuela"
            },
            {
                name: "LUIS AARON KURT MOSQUERA SOMAZA",
                dni: "RUT: 27106170-6",
                bank: "Banco prepago Tenpo",
                accountType: "Cuenta Vista",
                accountNumber: "111127106170",
                ticketPrice: "700 CLP",
                ticketPriceAmount: 700,
                ticketCurrency: "CLP",
                bankId: "tenpo"
            }
            ]

    },
    {
        accountId: 'moto-piruetas-vnz',
        bankAccounts: [
            {
                bankId: "mercantil",
                 name: "Banco Mercantil",
                 dni: "Cédula: V25.482.515",
                 bank: "Banco Mercantil 🇻🇪",
                 accountType: "Pago movil",
                 accountNumber: "04241623241",
                 ticketPrice: "75 BS",
                 ticketPriceAmount: 75,
                 href: '-',
                 ticketCurrency: "BS",
            },
            {
                bankId: 'bancofalabella',
                name: "Martinique Montilla",
                dni: "Rut: 26792739-1",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "1-520-014570-9",
                ticketPrice: "400 pesos",
                ticketPriceAmount: 400,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "zelle",
                bank: "Zelle",
                name: 'hmanthonyj@gmail.com',
                accountNumber: 'hmanthonyj@gmail.com',
                ticketPrice: "$0.4 dólar",
                ticketPriceAmount: 0.4,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'rifas-talca',
        bankAccounts: [
            {
                bankId: 'mercadopago',
                name: "Leomara Merlo",
                dni: "Rut: 26411595-7",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1035498080",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            { 
                bankId: 'bancoestado',
                name: "Leomara Merlo",
                dni: "Rut: 26.411.595-7",
                bank: "Banco Estado",
                accountType: "Cuenta Corriente",
                accountNumber: "37100056039",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'gana-con-salazar',
        bankAccounts: [
            {
                "name": "BDV - Pago Móvil",
                "href": "-",
                "dni": "Cédula: V-27.028.012",
                "bank": "Banco Venezuela - Pago Móvil 🇻🇪",
                "accountNumber": "04241318472",
                "ticketPrice": "0.5 dólar ó 100Bs",
                "ticketPriceAmount": 100,
                "ticketCurrency": "BS",
                "conversion": {
                    "dolarPrice": 100,
                    "dolarPriceCurrency": "BS"
                },
                "bankId": "bancodevenezuela"
            },
            {
                "name": "Wuilfredo Salazar",
                "bank": "Zelle",
                "accountNumber": "+1 2107083581",
                "ticketPrice": "$0.5 dólar",
                "ticketPriceAmount": 0.5,
                "ticketCurrency": "USD",
                "conversion": {
                    "dolarPrice": 0,
                    "dolarPriceCurrency": ""
                },
                "bankId": "zelle"
            },
            {
                name: "Yonner Eduardo Rangel Uzcategui",
                bank: "Zelle",
                accountNumber: "2104458461",
                ticketPrice: "$0.5 dólares",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD",
                bankId: "zelle"
            },
        ],
        
    },
    {
        accountId: 'billy-y-sus-rifas',
        bankAccounts: [
            {
                bankId: 'mercadopago',
                name: "Angelo Jose Albarran Ojeda",
                dni: "Rut: 26908939-3",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1073466250",
                ticketPrice: "700 pesos",
                ticketPriceAmount: 700,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: "bci",
                name: "ANGELO JOSE ALBARRAN",
                dni: "RUT: 26.908.939-3",
                bank: "Banco BCI🇨🇱",
                accountNumber: "89797639",
                accountType: "Cuenta Corriente",
                ticketPrice: "700 CLP",
                ticketPriceAmount: 700,
                href: '-',
                ticketCurrency: "CLP",
            },
            {
                name: "ANGELO JOSE ALBARRAN OJEDA",
                dni: "RUT: 26908939-3",
                bank: "Banco prepago Tenpo",
                accountType: "Cuenta Vista",
                accountNumber: "111126908939",
                ticketPrice: "700 CLP",
                ticketPriceAmount: 700,
                ticketCurrency: "CLP",
                bankId: "tenpo"
            },
            { 
                bankId: 'bancoestado',
                name: "ANGELO JOSE ALBARRAN OJEDA",
                dni: "Rut: 26908939-3",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "26908939",
                ticketPrice: "700 pesos",
                ticketPriceAmount: 700,
                href: '-',
                ticketCurrency: "CLP"
            },
        ]
    },
    {
        accountId: 'ray-ray',
        bankAccounts: [
            {
                name: "-",
                bank: "Binance",
                accountNumber: "Binance ID: 896795141",
                ticketPrice: "0.70 USDT",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USDT",
                bankId: "binance"
            },
            {
                name: "-",
                bank: "Zelle",
                accountNumber: "Liya88sanchez@gmail.com",
                ticketPrice: "$0.70 dólares",
                ticketPriceAmount: 0.7,
                ticketCurrency: "USD",
                bankId: "zelle"
            },
            {
                name: "William Avendaño",
                bank: "Nequi",
                accountType: "Billetera",
                accountNumber: "3132403993",
                ticketPrice: "700 COP",
                ticketPriceAmount: 700,
                ticketCurrency: "COP",
                bankId: "nequi"
            },
            {
                name: "-",
                bank: "Pago Móvil BDV",
                accountType: "Pago móvil",
                dni: "V-17640278",
                accountNumber: "04245098237",
                ticketPrice: "150 BS",
                ticketPriceAmount: 150,
                ticketCurrency: "BS",
                bankId: "bancodevenezuela"
            },
            {
                name: "Luis García",
                bank: "Banco Estado",
                accountType: "Cuenta Vista",
                accountNumber: "279496515",
                ticketPrice: "700 CLP",
                ticketPriceAmount: 700,
                ticketCurrency: "CLP",
                bankId: "bancoestado"
            },
            {
                name: "LUIS GARCIA",
                dni: "RUT: 27949651-5",
                bank: "Banco prepago Tenpo",
                accountType: "Cuenta Vista",
                accountNumber: "111127949651",
                ticketPrice: "700 CLP",
                ticketPriceAmount: 700,
                ticketCurrency: "CLP",
                bankId: "tenpo"
            }
            ]

    },
    {
        accountId: 'super-rifas-latam',
        bankAccounts: [
             {
                bankId: "pagomovil",
                dni: "Cédula: V-25.145.596",
                name: "BDV - Pago Móvil",
                bank: "Banco Venezuela - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04120521773",
                ticketPrice: "6.5 dólar ó 680bs",
                ticketPriceAmount: 680,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 104,
                    dolarPriceCurrency: "BS",
                }
            },
             {
                bankId: "bancodevenezuela",
                dni: "Cédula: V-25.145.596",
                name: "BDV - Cuenta Corriente",
                bank: "Banco Venezuela",
                accountNumber: "0412052177301020112840000576479",
                ticketPrice: "6.5 dólar ó 680bs",
                ticketPriceAmount: 680,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 104,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: "zelle",
                bank: "Zelle",
                name: 'Zelle',
                accountNumber: 'leosegoviafalcon@gmail.com',
                ticketPrice: "$6.5 dólar",
                ticketPriceAmount: 6.5,
                ticketCurrency: "USD"
            },
            {
                bankId: "binance",
                bank: "Binance",
                name: 'Binance',
                accountNumber: 'marielenagilv@gmail.com',
                ticketPrice: "$6.5 dólar",
                ticketPriceAmount: 6.5,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'alta-gama',
        bankAccounts: [
             {
                bankId: "bancodevenezuela",
                dni: "Cédula: V-19.966.638",
                name: "BDV - Pago Móvil",
                bank: "Banco Venezuela - Pago Móvil 🇻🇪",
                accountNumber: "-",
                phone: "04124090368",
                ticketPrice: "2 dólar ó 480bs",
                ticketPriceAmount: 480,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 240,
                    dolarPriceCurrency: "BS",
                }
            },
            {
                bankId: 'mercadopago',
                name: "Cesar Becerit",
                dni: "Rut: 263501659",
                bank: "Mercado Pago 🇨🇱",
                accountType: "Cuenta Vista",
                accountNumber: "1066858044",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'zelle',
                bank: "Zelle 🇻🇪 🇺🇸",
                name: "Jonanyelis González",
                accountNumber: '3056088297',
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: 'danielcontrerasrifas',
        bankAccounts: [
            {
                name: "Juan Carlos Perez Rodriguez",
                dni: "Rut: 26.669.894-1",
                bank: "Banco Falabella 🇨🇱",
                accountType: "Cuenta Corriente",
                accountNumber: "1-253-002108-2",
                ticketPrice: "500 pesos",
                ticketPriceAmount: 500,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bank: "Zelle 🇻🇪 🇺🇸",
                name: "Fausto Contreras",
                dni: "danielcontrerasrifas@gmail.com",
                ticketPrice: "$0.5 dólar",
                ticketPriceAmount: 0.5,
                ticketCurrency: "USD"
            },
            {
                dni: "Cédula: V-26.807.287",
                name: "Martha Cecilia Perez Rodriguez",
                bank: "Banco Venezuela - Pago Móvil 🇻🇪",
                accountNumber: "04168782745",
                ticketPrice: "0.5 dólar ó 23.8Bs",
                ticketPriceAmount: 23.8,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 47.55,
                    dolarPriceCurrency: "BS",
                }
            },
            // {
            //     bank: "Paypal",
            //     accountNumber: "danielcontrerasrifas@gmail.com",
            //     dni: "danielcontrerasrifas@gmail.com",
            //     ticketPrice: "$0.5 dólar",
            //     ticketPriceAmount: 0.5,
            //     ticketCurrency: "USD"
            // },
        ]
    },
    {
        accountId: "galenstar",
        bankAccounts: [
            {
                name: 'Bancamiga',
                bankId: 'bancaamiga',
                dni: "Cédula: V-22.032.943",
                bank: "Bancamiga 🇻🇪",
                phone: "04142478953",
                accountNumber: '-',
                accountType: "Pago Móvil",
                ticketPrice: "300Bs",
                ticketPriceAmount: 300,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 150, 
                    dolarPriceCurrency: "BS",
                }
            },


            {
                name: 'Baneso Panama',
                bankId: 'banesco',
                bank: "Banesco Panama 🇵🇦",
                accountType: "Cuenta de Ahorro",
                accountNumber: "221021511168",
                ticketPrice: "2 USD",
                ticketPriceAmount: 2,
                href: '-',
                ticketCurrency: "BS",
            },

             { 
                bankId: 'bancoestado',
                name: "Keila Vilchez",
                dni: "Rut: 27.218.432-1",
                bank: "Banco Estado",
                accountType: "Cuenta RUT",
                accountNumber: "27218432",
                ticketPrice: "2000 pesos",
                ticketPriceAmount: 2000,
                href: '-',
                ticketCurrency: "CLP"
            },
            {
                bankId: 'zelle',
                name: "Gabriela Sequera",
                bank: "Zelle",
                accountNumber: "3053401223",
                ticketPrice: "$2 dólar",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
            {
                bankId: 'binance',
                bank: "Binance",
                name: "Binance",
                accountNumber: "faui_14@hotmail.com",
                ticketPrice: "$2 dólares",
                ticketPriceAmount: 2,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "aurora-graterol",
        bankAccounts: [
            {
                "name": "Banco de Venezuela",
                "href": "-",
                "dni": "Cédula: V-24.478.156",
                "bank": "Banco De Venezuela",
                "accountNumber": "04248199309",
                "ticketPrice": "1 dólar ó 205Bs",
                "ticketPriceAmount": 205,
                "ticketCurrency": "BS",
                "conversion": {
                    "dolarPrice": 205,
                    "dolarPriceCurrency": "BS"
                },
                "bankId": "bancodevenezuela"
            },
            {
                "name": "Bancamiga",
                "href": "-",
                "dni": "Cédula: V-28.308.826",
                "bank": "Bancamiga 🇻🇪",
                "accountType": "Pago Móvil",
                "accountNumber": "-",
                "ticketPrice": "205Bs",
                "ticketPriceAmount": 205,
                "ticketCurrency": "BS",
                "conversion": {
                    "dolarPrice": 205,
                    "dolarPriceCurrency": "BS"
                },
                "bankId": "bancaamiga",
                "phone": "04248199338"
            },
            {
                "name": "JHON SANGUINO",
                "bank": "Bizum 🇪🇸",
                "accountNumber": "604281749",
                "ticketPrice": "$1.10 euros",
                "ticketPriceAmount": 1.1,
                "ticketCurrency": "USD",
                "conversion": {
                    "dolarPrice": 0,
                    "dolarPriceCurrency": ""
                },
                "bankId": "bizum"
            },
            {
                "name": "Binance",
                "bank": "Binance",
                "accountNumber": "kort.alejandro@gmail.com",
                "ticketPrice": "$1 dólares",
                "ticketPriceAmount": 1,
                "ticketCurrency": "USD",
                "conversion": {
                    "dolarPrice": 0,
                    "dolarPriceCurrency": ""
                },
                "bankId": "binance"
            },
            {
                bankId: 'zelle',
                name: "Derek Bernal",
                bank: "Zelle",
                dni: "bernalderek56@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
    {
        accountId: "maikel-jaimez",
        bankAccounts: [
            { 
                bankId: 'bancodevenezuela',
                name: 'Maikel Jaimez',
                dni: "Cédula: V-11.314.875",
                bank: "Banco De Venezuela",
                accountNumber: "04141547202",
                ticketPrice: "1 dólar ó 98Bs",
                ticketPriceAmount: 98,
                href: '-',
                ticketCurrency: "BS",
                conversion: {
                    dolarPrice: 98,
                    dolarPriceCurrency: "BS",
                }
            }, 
            {
                bankId: 'bci',
                dni: "RUT: 28.113.514-7",
                name: "Jose Martinez",
                accountType: "Cuenta Corriente",
                bank: "BCI/MACH 🇨🇱",
                accountNumber: "777928113514",
                ticketPrice: "1000 pesos",
                ticketPriceAmount: 1000,
                href: '-',
                ticketCurrency: "CLP",
            },
            {
                bankId: 'zelle',
                name: "Gerson Morales",
                bank: "Zelle",
                dni: "elbarbergrau175@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                bankId: 'plin',
                name: "Maikel Jaimez",
                accountType: 'Yape',
                bank: "Yape Perú 🇵🇪",
                dni: "+51 921 565 925",
                ticketPrice: "4 soles",
                ticketPriceAmount: 4,
                ticketCurrency: "SOL"
            }
        ]
    },
    {
        accountId: "blessed-disc-bar-zz",
        bankAccounts: [
            {
                bankId: "bancolombia",
                name: "Pablo Emiliano Díaz Gutiérrez",
                bank: "Bancolombia",
                dni: "Cédula: 1046743290",
                accountType: "Cuenta de Ahorro",
                accountNumber: "31156081330",
                ticketPrice: "5000 pesos",
                ticketPriceAmount: 5000,
                href: '-',
                ticketCurrency: "COP"
            },
            {
                bankId: "bancodevenezuela",
                name: "Banco de Venezuela",
                dni: "Cédula: V26.509.044",
                bank: "Banco de Venezuela",
                accountType: "Cuenta de Ahorro",
                accountNumber: "-",
                phone: "04242114511",
                ticketPrice: "20 bs",
                ticketPriceAmount: 20,
                href: '-',
                ticketCurrency: "BS"
            },
            {
                bankId: "zelle",
                bank: "Zelle 🇺🇸",
                name: 'Yilianny Gabriela',
                dni: 'Mínima compra 2 tickets. Añadir número de confirmación completo.',
                accountNumber: "yiliannygabriela@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
            {
                name: 'Binance',
                bankId: 'binance',
                bank: "Binance",
                accountNumber: "yelitzazb.23@gmail.com",
                dni: "yelitzazb.23@gmail.com",
                ticketPrice: "$1 dólar",
                ticketPriceAmount: 1,
                ticketCurrency: "USD"
            },
        ]
    },
]
